import React, { useState, useEffect, useCallback, useRef } from "react";
import { 
  CreateTable,
  SuccessMessage,
  FailMessage,
  ConfirmationModal,
  Loading,
  FormatValueToDecimal,

  // DrAccountsReceivablesChartOfAccountsSelect,
  // CrAccountsReceivablesChartOfAccountsSelect,
  ChartOfAccountsSelect,
  CustomerSelect,
  DateSelect,
  BillingTypeSelect,
  CreditTermSelect,
  DeliveryOrderCustomerSelect,
  DetectMimeTypeFromBase64, HandleFileUpload, DownloadFile,
  InvoiceStatusSelectWithAll, GetAccountConfiguration
} from "../../common/APICommon";
import { apiUrl } from "../../utils/Configuration";
import axios from 'axios';
import { motion, AnimatePresence } from "framer-motion";
import NoAccess from "../NoAccess";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
// MUI Icons
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import EditIcon from '@mui/icons-material/Edit';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import ManageSearchIcon from '@mui/icons-material/ManageSearch';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import PersonSearchIcon from '@mui/icons-material/PersonSearch';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ListAltIcon from '@mui/icons-material/ListAlt';
import VisibilityIcon from '@mui/icons-material/Visibility';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import NotInterestedIcon from '@mui/icons-material/NotInterested';


export const SalesInvoice = ({active}) => {
//#region Others
  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [failMessage, setFailMessage] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [search, setSearch] = useState("");

  const handleSearch = (value) => {
    setSearch(value);
    setCurrentPage(1)
    const lowerValue = value.toLowerCase();

    const filtered = filteredData.filter(
      (item) =>
        item.salesInvoiceNumber?.toLowerCase().includes(lowerValue) ||
        item.orderNumber?.toLowerCase().includes(lowerValue) ||
        item.customerName1?.toLowerCase().includes(lowerValue)
    );

    setData(filtered);
  };
//#endregion





//#region Filters
  const [showFilterForm, setShowFilterForm] = useState(false);
  const [statusFilter, setStatusFilter] = useState("All");
  const [customerFilter, setCustomerFilter] = useState(null);
  const openFilterForm = () => {
    setShowFilterForm(true);
  }
  const closeFilterForm = () => {
    setShowFilterForm(false);
  }
//#endregion








//#region Variables
  const [selectedData, setSelectedData] = useState(null);

  const [salesInvoiceDetails, setSalesInvoiceDetails] = useState([]);
  const [lineItemSelections, setLineItemSelections] = useState([]);
  const [customer, setCustomer] = useState(null);
  const [salesInvoiceNumber, setSalesInvoiceNumber] = useState("xxxxxx");

  /* const accountReceivable = {
    id: 12,
    accountName: "Accounts Receivable",
    accountNumber: "10020",
    glAccountSubTypeId: 1,
    isActive: true,
  } */

  const [accountInit, setAccountInit] = useState(null);
  const [account, setAccount] = useState(accountInit);


  const [orderNumber, setOrderNumber] = useState("");
  const today = new Date().toISOString().split("T")[0];
  const [salesInvoiceDate, setSalesInvoiceDate] = useState(today);
  const [dueDate, setDueDate] = useState(today);
  const [billingType, setBillingType] = useState(null);
  const [creditTerm, setCreditTerm] = useState(null);
  const [totalAmount, setTotalAmount] = useState(0);
  const [amountPaid, setAmountPaid] = useState(0);
  const [vat, setVAT] = useState(0);
  const [discounts, setDiscounts] = useState(0);
  const [zeroRated, setZeroRated] = useState(0);
  const [ewt, setEWT] = useState(0);
  const [subTotal, setSubTotal] = useState(0);
  const [status, setStatus] = useState("");
  const [notes, setNotes] = useState("");
  const [creditNotesAmount, setCreditNotesAmount] = useState(0);
  const [uploadedFile, setUploadedFile] = useState("");

  const resetVariables = () => {
    setSalesInvoiceDetails([]);
    setCustomer(null);
    setSalesInvoiceNumber("xxxxxx");
    setOrderNumber("");
    setAccount(accountInit);
    setSalesInvoiceDate(today);
    setDueDate(today);
    setBillingType(null);
    setCreditTerm(null);
    setTotalAmount(0);
    setAmountPaid(0);
    setVAT(12);
    setDiscounts(0);
    setZeroRated(0);
    setEWT(0);
    setSubTotal(0);
    setStatus("");
    setNotes("");
    setUploadedFile("");
    setCreditNotesAmount(0);
    setLineItemSelections([])

    setSelectedData(null);
  }

  const fetchDataById = useCallback(async (_data) => {
    try {
      const response = await axios.get(`${apiUrl}/api/SalesInvoice/${_data?.id}` , {
        headers: { 'Content-Type': 'application/json'}
      })
        
      return (response.data)
    } catch (error) {
      console.error('Error fetching data:', error);
      return null
    }
  }, []);

  useEffect(() => {
    const init = async () => {
      const _config = await GetAccountConfiguration("salesInvoice", "Receivables")

      const _accountInit = {
        id: _config?.drGLAccountId ?? 0,
        accountName: _config?.drGLAccountName ?? "",
        accountNumber: _config?.drGLAccountNumber ?? "",
        isActive: true,
      }

      setAccountInit(_accountInit)
      setAccount(_accountInit)
    }

    init();
  }, [])
//#endregion







// #region Add function
  const [showAddForm, setShowAddForm] = useState(false);
  
  const openAddForm = () => {
    setShowAddForm(true);
  }
  const closeAddForm = () => {
    setShowAddForm(false);
    resetVariables();
  }

  /* const generateNumber = useCallback(async () => {
    try {
      const response = await axios.get(`${apiUrl}/api/SalesInvoice/generate-number` , {
        headers: { 'Content-Type': 'application/json'}
      })
        
      return (response.data)
    } catch (error) {
      console.error('Error fetching data:', error);
      return ""
    }
  }, []); */

  const addHandleClick = async () => {
    setLoading(true)

    /* const _number = await generateNumber();
    setSalesInvoiceNumber(_number?.number) */

    setLoading(false)
    openAddForm()
  }

  const handleAddData = async () => {
    const _lineItemSelections = lineItemSelections.map((item) => ({
      lineItemId: item.lineItemId, 
      debitAccountId: item.debitAccount?.id ?? null, 
      creditAccountId: item.creditAccount?.id ?? null, 
    }))

    const data = {
      salesInvoiceDetails: salesInvoiceDetails,
      lineItemSelections: _lineItemSelections,
      customerId: customer?.customerId,
      salesInvoiceNumber: salesInvoiceNumber,
      accountId: account?.id,
      orderNumber: orderNumber,
      salesInvoiceDate: salesInvoiceDate,
      dueDate: dueDate,
      billingTypeId: billingType?.id,
      creditTermId: creditTerm?.id,
      totalAmount: totalAmount,
      amountPaid: amountPaid,
      vat: vat,
      discounts: discounts,
      zeroRated: zeroRated,
      ewt: ewt,
      subTotal: subTotal,
      status: "Open",
      notes: notes,
      uploadedFile: uploadedFile?.base64,
      createdDate: new Date(),
      createdBy: accountData?.id,
    };

    try {
      setLoading(true);

      await axios.post(`${apiUrl}/api/SalesInvoice`, data, {
          headers: { 'Content-Type': 'application/json' }
      });
      
      await fetchData();
      setSuccessMessage("Data added successfully!");
    } catch (error) {
      console.error('There was a problem adding data:', error);
      const errorMessage = JSON.parse(error.response.request.responseText).message;
      setFailMessage(`Failed to add data: ${errorMessage}`);
    } finally {
      setLoading(false);
    }
  } 
//#endregion






// #region Update function
  const [showUpdateForm, setShowUpdateForm] = useState(false);
  
  const openUpdateForm = () => {
    setShowUpdateForm(true);
  }
  const closeUpdateForm = () => {
    setShowUpdateForm(false);
    resetVariables();
  }

  const editHandleClick = async (data) => {
    setLoading(true);

    const _data = await fetchDataById(data);
    setSelectedData(_data);

    setSalesInvoiceDetails(_data.salesInvoiceDetails ?? []);

    let lineItemSelections = [];

    _data?.salesInvoiceDetails?.forEach((item) => {
      item.deliveryOrder?.deliveryOrderDetailLines?.forEach((line) => {
        lineItemSelections.push({
          lineItemId: line.id,
          debitAccount: line.drAccount ?? null,
          creditAccount: line.crAccount ?? null,
        });
      });
    });

    setLineItemSelections(lineItemSelections);

    setCustomer(_data.customer ?? null);
    setSalesInvoiceNumber(_data.salesInvoiceNumber ?? "");
    setOrderNumber(_data.orderNumber ?? "");
    setAccount(_data.account ?? null);
    setSalesInvoiceDate(_data.salesInvoiceDate ?? null);
    setDueDate(_data.dueDate ?? null);
    setBillingType(_data.billingType ?? null);
    setCreditTerm(_data.creditTerm ?? null);
    setTotalAmount(_data.totalAmount ?? 0);
    setAmountPaid(_data.amountPaid ?? 0);
    setVAT(_data.vat ?? 0);
    setDiscounts(_data.discounts ?? 0);
    setZeroRated(_data.zeroRated ?? 0);
    setEWT(_data.ewt ?? 0);
    setSubTotal(_data.subTotal ?? 0);
    setStatus(_data.status ?? "");
    setNotes(_data.notes ?? "");
    setCreditNotesAmount(_data.creditNotesAmount ?? 0);
    setUploadedFile(_data.uploadedFile
                ? {
                    base64: _data.uploadedFile,
                    contentType: DetectMimeTypeFromBase64(
                      _data.uploadedFile
                    ),
                    fileName: `UploadedFile.${DetectMimeTypeFromBase64(
                      _data.uploadedFile
                    ).split("/")[1]}`
                  }
                : null)

    setLoading(false);
    openUpdateForm();
  }

  const handleUpdateData = async () => {
    const _lineItemSelections = lineItemSelections.map((item) => ({
      lineItemId: item.lineItemId, 
      debitAccountId: item.debitAccount?.id ?? null, 
      creditAccountId: item.creditAccount?.id ?? null, 
    }))

    const data = {
      salesInvoiceDetails: salesInvoiceDetails,
      lineItemSelections: _lineItemSelections,
      customerId: customer?.customerId,
      salesInvoiceNumber: salesInvoiceNumber,
      orderNumber: orderNumber,
      accountId: account?.id,
      salesInvoiceDate: salesInvoiceDate,
      dueDate: dueDate,
      billingTypeId: billingType?.id,
      creditTermId: creditTerm?.id,
      totalAmount: totalAmount,
      amountPaid: amountPaid,
      vat: vat,
      discounts: discounts,
      zeroRated: zeroRated,
      ewt: ewt,
      subTotal: subTotal,
      status: status,
      notes: notes,
      uploadedFile: uploadedFile?.base64,
      updatedDate: new Date(),
      updatedBy: accountData?.id,
    };

    try {
      setLoading(true);

      await axios.post(`${apiUrl}/api/SalesInvoice/update/${selectedData?.id}`, data, {
          headers: { 'Content-Type': 'application/json' }
      });
      
      await fetchData();
      setSuccessMessage("Data updated successfully!");
    } catch (error) {
      console.error('There was a problem adding data:', error);
      const errorMessage = JSON.parse(error.response.request.responseText).message;
      setFailMessage(`Failed to add data: ${errorMessage}`);
    } finally {
      setLoading(false);
    }
  } 
//#endregion







// #region View function
  const [showViewForm, setShowViewForm] = useState(false);
  
  const openViewForm = () => {
    setShowViewForm(true);
  }
  const closeViewForm = () => {
    setShowViewForm(false);
    resetVariables();
  }

  const viewHandleClick = async (data) => {
    setLoading(true);

    const _data = await fetchDataById(data);
    setSelectedData(_data);

    setSalesInvoiceDetails(_data.salesInvoiceDetails ?? []);

    let lineItemSelections = [];

    _data?.salesInvoiceDetails?.forEach((item) => {
      item.deliveryOrder?.deliveryOrderDetailLines?.forEach((line) => {
        lineItemSelections.push({
          lineItemId: line.id,
          debitAccount: line.drAccount ?? null,
          creditAccount: line.crAccount ?? null,
        });
      });
    });

    setLineItemSelections(lineItemSelections);

    setCustomer(_data.customer ?? null);
    setSalesInvoiceNumber(_data.salesInvoiceNumber ?? "");
    setOrderNumber(_data.orderNumber ?? "");
    setAccount(_data.account ?? null);
    setSalesInvoiceDate(_data.salesInvoiceDate ?? null);
    setDueDate(_data.dueDate ?? null);
    setBillingType(_data.billingType ?? null);
    setCreditTerm(_data.creditTerm ?? null);
    setTotalAmount(_data.totalAmount ?? 0);
    setAmountPaid(_data.amountPaid ?? 0);
    setVAT(_data.vat ?? 0);
    setDiscounts(_data.discounts ?? 0);
    setZeroRated(_data.zeroRated ?? 0);
    setEWT(_data.ewt ?? 0);
    setSubTotal(_data.subTotal ?? 0);
    setStatus(_data.status ?? "");
    setNotes(_data.notes ?? "");
    setCreditNotesAmount(_data.creditNotesAmount ?? 0);
    setUploadedFile(_data.uploadedFile
                ? {
                    base64: _data.uploadedFile,
                    contentType: DetectMimeTypeFromBase64(
                      _data.uploadedFile
                    ),
                    fileName: `UploadedFile.${DetectMimeTypeFromBase64(
                      _data.uploadedFile
                    ).split("/")[1]}`
                  }
                : null)

    setLoading(false);
    openViewForm();
  }
//#endregion







// #region View Sales Invoice Account
  const [selectedGLAccount, setSelectedGLAccount] = useState(null);
  const [showViewGLAccountForm, setShowViewGLAccountForm] = useState(false);
  
  const openViewGLAccountForm = () => {
    setShowViewGLAccountForm(true);
  }
  const closeViewGLAccountForm = () => {
    setShowViewGLAccountForm(false);
    setSelectedGLAccount(null);
    setLineItemSelections([])
  }

  const viewGLAccountHandleClick = async (data) => {
    setLoading(true);
    const _data = await fetchDataById(data);
    setSelectedGLAccount(_data?.salesInvoiceDetails ?? []);

    let lineItemSelections = [];

    _data?.salesInvoiceDetails?.forEach((item) => {
      item.deliveryOrder?.deliveryOrderDetailLines?.forEach((line) => {
        lineItemSelections.push({
          lineItemId: line.id,
          debitAccount: line.drAccount ?? null,
          creditAccount: line.crAccount ?? null,
        });
      });
    });

    setLineItemSelections(lineItemSelections);

    setLoading(false)
    openViewGLAccountForm();
  }
// #endregion








// #region Cancel Invoice
  const [showCancelForm, setShowCancelForm] = useState(false);

  const openCancelForm = () => {
    setShowCancelForm(true);
  }
  const closeCancelForm = () => {
    setShowCancelForm(false);
  }

  const cancelHandleClick = async (data) => {
    setSelectedData(data);
    openCancelForm();
  }

  const handleCancelStatus = async () => {
    try {
      setLoading(true);

      const _data = {
        id: selectedData?.id,
        status: "Cancelled"
      }

      await axios.post(`${apiUrl}/api/SalesInvoice/change-status`, _data, {
          headers: { 'Content-Type': 'application/json' }
      });
      
      await fetchData();
      setSuccessMessage("Data updated successfully!");
    } catch (error) {
      console.error('There was a problem adding data:', error);
      const errorMessage = JSON.parse(error.response.request.responseText).message;
      setFailMessage(`Failed to change data: ${errorMessage}`);
    } finally {
      setLoading(false)
    }
  }
// #endregion








//#region Table data
  const [currentPage, setCurrentPage] = useState(1);
  const [data, setData] = useState([]);

  const headers = [
    'SI NUMBER', 
    'CUSTOMER', 
    // 'DUE DATE', 
    'DELIVERY ORDER/S', 
    // 'SALES AMOUNT', 
    'AMOUNT DUE', 
    // 'ADJUSTMENTS', 
    'CREDIT AMOUNT', 
    'AMOUNT PAID', 
    'STATUS', 
    'ACTIONS',
  ]
  const accessors = [
    'salesInvoiceNumber', 
    'customer', 
    // 'dueDate', 
    'salesInvoiceDetails', 
    // 'salesInvoiceDetailsAmount', 
    'amountDue', 
    // 'adjustments', 
    'creditNotesAmount', 
    'amountPaid', 
    'status', 
    'actions'
  ]

  const actions = [
    { 
      name: "View", 
      tooltip: "view",
      icon: <VisibilityIcon fontSize="small" />,
      className: "bg-sky-500 hover:bg-sky-600",
      function: viewHandleClick,
      visible: true,
    },
    { 
      name: "Edit", 
      tooltip: "edit",
      icon: <EditIcon fontSize="small" />,
      className: "bg-green-500 hover:bg-green-600",
      function: editHandleClick,
      visible: true,
    },
    { 
      name: "Cancel", 
      tooltip: "cancel",
      icon: <NotInterestedIcon fontSize="small" />,
      className: "bg-red-500 hover:bg-red-600",
      function: cancelHandleClick,
      visible: true,
    },
    { 
      name: "View Sales Invoice Account", 
      tooltip: "view",
      icon: <ListAltIcon fontSize="small" />,
      className: "bg-sky-500 hover:bg-sky-600",
      function: viewGLAccountHandleClick,
      visible: false,
    },
  ];

  const fetchData = useCallback(async () => {
    try {
      setLoading(true);

      const response = await axios.get(`${apiUrl}/api/SalesInvoice/customer/${customerFilter?.customerId ?? "All"}/status/${statusFilter ? statusFilter : "All"}` , {
        headers: { 'Content-Type': 'application/json'}
      })
        
      setData(response.data)
      setFilteredData(response.data)
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false);
    }
  }, [ customerFilter,  statusFilter ]);

  useEffect(() => {
    if(active){
      fetchData();
    }
  }, [active, fetchData])
//#endregion










//#region Access Template
  const accountData = JSON.parse(localStorage.getItem("accountData"));
  
  if (!accountData?.accessTemplate?.hasReceivables) {
    return <NoAccess />;
  }
//#endregion


  return (
    <>
      <div className="py-6 bg-gray-50 min-h-screen">
        {/* Header Section */}
        <div className="flex flex-col md:flex-row md:items-center justify-between mb-8 gap-4">
          {/* Search and Filters */}
          <div className="flex justify-between items-center gap-2 w-full">
            <div className="w-full">
              <input
                type="text"
                placeholder="Search account..."
                className="px-4 py-2 border rounded-lg w-full md:w-2/3 focus:outline-none focus:ring-2 focus:ring-theme-color focus:border-theme-color"
                value={search}
                onChange={(e) => handleSearch(e.target.value)}
              />
              {/* Add filter dropdowns here if needed */}
            </div>
          </div>
          <div className="flex gap-3 w-full justify-start md:justify-end">
            <button className="bg-white border border-gray-300 text-theme-color hover:bg-gray-100 px-3 py-1 rounded-md flex items-center gap-2 hover:bg-opacity-90 transition"
              onClick={openFilterForm}
            >
              <FilterAltIcon/> Filter
            </button>
            <button onClick={addHandleClick} className="flex items-center gap-2 bg-theme-color text-white px-4 py-2 rounded-lg text-sm font-semibold hover:bg-theme-color-h transition shadow-md">
              <AddCircleOutlineIcon fontSize="small" /> New Invoice
            </button>
          </div>
        </div>

        <CreateTable
          tableName={"Sales Invoice"}
          headers={headers}
          accessors={accessors}
          data={data}
          actions={actions}

          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          itemsPerPage={10}
          totalItems={data?.length}
        />
      </div>

      <AddUpdateModal 
        visible={showAddForm}
        onClose={closeAddForm}
        onSave={handleAddData}
        modalName={"Add Sales Invoice"}

        data={data}
        salesInvoiceDetails={salesInvoiceDetails} setSalesInvoiceDetails={setSalesInvoiceDetails}
        customer={customer} setCustomer={setCustomer}
        salesInvoiceNumber={salesInvoiceNumber} setSalesInvoiceNumber={setSalesInvoiceNumber}
        orderNumber={orderNumber} setOrderNumber={setOrderNumber}
        salesInvoiceDate={salesInvoiceDate} setSalesInvoiceDate={setSalesInvoiceDate}
        account={account} setAccount={setAccount}
        dueDate={dueDate} setDueDate={setDueDate}
        billingType={billingType} setBillingType={setBillingType}
        creditTerm={creditTerm} setCreditTerm={setCreditTerm}
        totalAmount={totalAmount} setTotalAmount={setTotalAmount}
        amountPaid={amountPaid} setAmountPaid={setAmountPaid}
        vat={vat} setVAT={setVAT}
        discounts={discounts} setDiscounts={setDiscounts}
        zeroRated={zeroRated} setZeroRated={setZeroRated}
        ewt={ewt} setEWT={setEWT}
        subTotal={subTotal} setSubTotal={setSubTotal}
        status={status} setStatus={setStatus}
        notes={notes} setNotes={setNotes}
        uploadedFile={uploadedFile} setUploadedFile={setUploadedFile}
        creditNotesAmount={creditNotesAmount} setCreditNotesAmount={setCreditNotesAmount}
        lineItemSelections={lineItemSelections} setLineItemSelections={setLineItemSelections}
        isEditable={true}
      />

      <AddUpdateModal 
        visible={showUpdateForm}
        onClose={closeUpdateForm}
        onSave={handleUpdateData}
        modalName={"Update Sales Invoice"}

        data={data}
        salesInvoiceDetails={salesInvoiceDetails} setSalesInvoiceDetails={setSalesInvoiceDetails}
        customer={customer} setCustomer={setCustomer}
        salesInvoiceNumber={salesInvoiceNumber} setSalesInvoiceNumber={setSalesInvoiceNumber}
        orderNumber={orderNumber} setOrderNumber={setOrderNumber}
        account={account} setAccount={setAccount}
        salesInvoiceDate={salesInvoiceDate} setSalesInvoiceDate={setSalesInvoiceDate}
        dueDate={dueDate} setDueDate={setDueDate}
        billingType={billingType} setBillingType={setBillingType}
        creditTerm={creditTerm} setCreditTerm={setCreditTerm}
        totalAmount={totalAmount} setTotalAmount={setTotalAmount}
        amountPaid={amountPaid} setAmountPaid={setAmountPaid}
        vat={vat} setVAT={setVAT}
        discounts={discounts} setDiscounts={setDiscounts}
        zeroRated={zeroRated} setZeroRated={setZeroRated}
        ewt={ewt} setEWT={setEWT}
        subTotal={subTotal} setSubTotal={setSubTotal}
        status={status} setStatus={setStatus}
        notes={notes} setNotes={setNotes}
        uploadedFile={uploadedFile} setUploadedFile={setUploadedFile}
        creditNotesAmount={creditNotesAmount} setCreditNotesAmount={setCreditNotesAmount}
        lineItemSelections={lineItemSelections} setLineItemSelections={setLineItemSelections}
        isEditable={true}
      />

      <ViewModal 
        visible={showViewForm}
        onClose={closeViewForm}
        // onSave={handleViewData}
        modalName={"View Sales Invoice"}

        data={data}
        salesInvoiceDetails={salesInvoiceDetails} setSalesInvoiceDetails={setSalesInvoiceDetails}
        customer={customer} setCustomer={setCustomer}
        salesInvoiceNumber={salesInvoiceNumber} setSalesInvoiceNumber={setSalesInvoiceNumber}
        orderNumber={orderNumber} setOrderNumber={setOrderNumber}
        account={account} setAccount={setAccount}
        salesInvoiceDate={salesInvoiceDate} setSalesInvoiceDate={setSalesInvoiceDate}
        dueDate={dueDate} setDueDate={setDueDate}
        billingType={billingType} setBillingType={setBillingType}
        creditTerm={creditTerm} setCreditTerm={setCreditTerm}
        totalAmount={totalAmount} setTotalAmount={setTotalAmount}
        amountPaid={amountPaid} setAmountPaid={setAmountPaid}
        vat={vat} setVAT={setVAT}
        discounts={discounts} setDiscounts={setDiscounts}
        zeroRated={zeroRated} setZeroRated={setZeroRated}
        ewt={ewt} setEWT={setEWT}
        subTotal={subTotal} setSubTotal={setSubTotal}
        status={status} setStatus={setStatus}
        notes={notes} setNotes={setNotes}
        uploadedFile={uploadedFile} setUploadedFile={setUploadedFile}
        creditNotesAmount={creditNotesAmount} setCreditNotesAmount={setCreditNotesAmount}
        isEditable={false}
      />

      <ViewGLAccountModal 
        visible={showViewGLAccountForm}
        onClose={closeViewGLAccountForm}
        // onSave={handleUpdateData}
        modalName={"View Sales Invoice Accounts"}

        salesInvoiceDetails={selectedGLAccount} setSalesInvoiceDetails={setSelectedGLAccount}
        lineItemSelections={lineItemSelections} setLineItemSelections={setLineItemSelections}
      />

      <ConfirmationModal 
        visible={showCancelForm} 
        onClose={closeCancelForm} 
        onSave={handleCancelStatus} 
        modalName={"Cancel"} 
        message={`Do you want to cancel this invoice [ ${selectedData?.salesInvoiceNumber ?? ""} ]?.`}
      />

      <FilterModal 
        visible={showFilterForm}
        onClose={closeFilterForm}
        modalName={"Filter"}

        customerFilter={customerFilter} setCustomerFilter={setCustomerFilter}
        statusFilter={statusFilter} setStatusFilter={setStatusFilter}
      />

      <div className="fixed top-5 right-5 z-50 flex flex-col space-y-2">
        <SuccessMessage message={successMessage} onClose={() => setSuccessMessage("")} />
        <FailMessage message={failMessage} onClose={() => setFailMessage("")} />
      </div>

      { loading && <Loading />}
    </>
  );
}









//#region AddUpdate/View Modal
const AddUpdateModal = ({
  visible, onClose, onSave, modalName,
  salesInvoiceDetails, setSalesInvoiceDetails,
  customer, setCustomer,
  account, setAccount,
  salesInvoiceNumber, setSalesInvoiceNumber,
  orderNumber, setOrderNumber,
  salesInvoiceDate, setSalesInvoiceDate,
  dueDate, setDueDate,
  billingType, setBillingType,
  creditTerm, setCreditTerm,
  totalAmount, setTotalAmount,
  amountPaid, setAmountPaid,
  vat, setVAT,
  discounts, setDiscounts,
  zeroRated, setZeroRated,
  ewt, setEWT,
  subTotal, setSubTotal,
  status, setStatus,
  notes, setNotes,
  uploadedFile, setUploadedFile,
  creditNotesAmount, setCreditNotesAmount,
  lineItemSelections, setLineItemSelections,
  isEditable
}) => {
  const getCurrency = JSON.parse(localStorage.getItem("currency") || "{}");
  const [failMessage, setFailMessage] = useState("");
  const [showSalesInvoices, setShowSalesInvoices] = useState(true);
  const [collapsedDOs, setCollapsedDOs] = useState({});

  const toggleDO = (id) => {
    setCollapsedDOs((prev) => ({
      ...prev,
      [id]: !prev[id], // Toggle the collapsed state
    }));
  };




  const [activeTarget, setActiveTarget] = useState({ lineId: null, side: null });
  const [tempAccount, setTempAccount] = useState(null);

  // Handle when an account is selected from the modal
  useEffect(() => {
    if (tempAccount && activeTarget.lineId) {
        setLineItemSelections(prev => {
            // 1. Check if this line already has an entry in our array
            const existingIndex = prev.findIndex(item => item.lineItemId === activeTarget.lineId);
            const sideKey = activeTarget.side === 'dr' ? 'debitAccount' : 'creditAccount';

            if (existingIndex > -1) {
                // 2. Update existing entry
                const updatedArray = [...prev];
                updatedArray[existingIndex] = {
                    ...updatedArray[existingIndex],
                    [sideKey]: tempAccount
                };
                return updatedArray;
            } else {
                // 3. Add brand new entry
                return [...prev, {
                    lineItemId: activeTarget.lineId,
                    debitAccount: activeTarget.side === 'dr' ? tempAccount : null,
                    creditAccount: activeTarget.side === 'cr' ? tempAccount : null,
                }];
            }
        });

        // Reset and close
        setTempAccount(null);
        setActiveTarget({ lineId: null, side: null });
        closeLineItemDrAccountSelectForm();
        closeLineItemCrAccountSelectForm();
    }
  }, [tempAccount, activeTarget, setLineItemSelections]);

  const handleRemoveAccount = (lineId, sideKey) => {
    setLineItemSelections(prev => {
      return prev.map(item => {
        if (item.lineItemId === lineId) {
            return { ...item, [sideKey]: null };
        }
        return item;
      });
    });
  };






//#region Adjustments
  const [vatAmount, setVATAmount] = useState(0);
  const [discountAmount, setDiscountAmount] = useState(0);
  const [zeroRatedAmount, setZeroRatedAmount] = useState(0);
  const [ewtAmount, setEWTAmount] = useState(0);

  /* useEffect(() => {
    if (subTotal > 0 && visible) {
      // VAT
      const _vatPercent = vat / 100;

      // Discount
      const _discountPercent = discounts / 100;
      const _discountAmount = subTotal * _discountPercent;

      // Zero Rated
      const _zeroRatedPercent = zeroRated / 100;
      const _zeroRatedAmount = subTotal * _zeroRatedPercent;

      // VAT adjusted for Zero-Rated
      const _vatAmount = (subTotal - _discountAmount - _zeroRatedAmount) * _vatPercent;

      // EWT
      const _ewtPercent = ewt / 100;
      const _ewtAmount = (subTotal - _discountAmount) * _ewtPercent;

      // Set state
      setDiscountAmount(_discountAmount);
      setZeroRatedAmount(_zeroRatedAmount);
      setVATAmount(_vatAmount);
      setEWTAmount(_ewtAmount);

      // Compute total using freshly computed values
      const _totalAmount = subTotal - _discountAmount + _vatAmount - _ewtAmount;
      setTotalAmount(_totalAmount);
    }
  }, [setTotalAmount, subTotal, vat, discounts, zeroRated, ewt, visible]); */

  const resetLocalVariables = () => {
    setFailMessage("")
    setVATAmount(0);
    setDiscountAmount(0);
    setZeroRatedAmount(0);
    setEWTAmount(0);
    setCollapsedDOs({})
    setActiveTarget({ lineId: null, side: null });
    setTempAccount(null);
  }
//#endregion




//#region Customer
  const [showCustomerSelectForm, setShowCustomerSelectForm] = useState(false);
  const openCustomerSelectForm = () => {
    setShowCustomerSelectForm(true);
  }
  const closeCustomerSelectForm = () => {
    setShowCustomerSelectForm(false);
  }
//#endregion







  const [showGLAccountSelectForm, setShowGLAccountSelectForm] = useState(false);
  const openGLAccountSelectForm = () => {
    setShowGLAccountSelectForm(true);
  }
  const closeGLAccountSelectForm = () => {
    setShowGLAccountSelectForm(false);
  }

  const [showLineItemAccountDrSelectForm, setShowLineItemAccountDrSelectForm] = useState(false);
  const openLineItemDrAccountSelectForm = () => {
    setShowLineItemAccountDrSelectForm(true);
  }
  const closeLineItemDrAccountSelectForm = () => {
    setShowLineItemAccountDrSelectForm(false);
  }

  const [showLineItemAccountCrSelectForm, setShowLineItemAccountCrSelectForm] = useState(false);
  const openLineItemCrAccountSelectForm = () => {
    setShowLineItemAccountCrSelectForm(true);
  }
  const closeLineItemCrAccountSelectForm = () => {
    setShowLineItemAccountCrSelectForm(false);
  }







  const handleSubmit = async () => {
    // Logic updated to match your state requirements
    if (salesInvoiceDetails.length <= 0 
      || !salesInvoiceNumber
      || !salesInvoiceDate
      || !billingType
      || !creditTerm
      || !account
    ) {
      setFailMessage("Please fill up all required fields.");
      return;
    }
    await onSave();
    closeModal();
  };

  const closeModal = () => {
    resetLocalVariables();
    setFailMessage("");
    onClose();
  };









//#region GLAccount
  const [currentPageGLAccount, setCurrentPageGLAccount] = useState(1);

  const headersGLAccount = [
    'DO NUMBER', 
    'ACCOUNT', 
    // 'SUBTOTAL', 
    // 'TOTAL DISCOUNT', 
    // 'TAX AMOUNT', 
    'TOTAL AMOUNT', 
    ...(isEditable ? ['ACTIONS'] : [])
  ]
  const accessorsGLAccount = [
    'deliveryOrderDONumber', 
    'glAccountName', 
    // 'subTotal', 
    // 'totalDiscount', 
    // 'taxAmount', 
    'totalAmount', 
    ...(isEditable ? ['actions'] : [])
  ]

  const [showAddGLAccountForm, setShowAddGLAccountForm] = useState(false);
  const [selectedGLAccount, setSelectedGLAccount] = useState(null);
  const openAddGLAccountForm = () => {
    setShowAddGLAccountForm(true);
  }
  const closeAddGLAccountForm = () => {
    setShowAddGLAccountForm(false);
    setSelectedGLAccount(null)
  }

  const [showUpdateGLAccountForm, setShowUpdateGLAccountForm] = useState(false);
  const openUpdateGLAccountForm = () => {
    setShowUpdateGLAccountForm(true);
  }
  const closeUpdateGLAccountForm = () => {
    setShowUpdateGLAccountForm(false);
    setSelectedGLAccount(null)
  }

  const editHandleGLAccountClick = (_data) => {
    setSelectedGLAccount(_data)
    openUpdateGLAccountForm();
  }

  const [showDeleteGLAccountForm, setShowDeleteGLAccountForm] = useState(false);
  const openDeleteGLAccountForm = () => {
    setShowDeleteGLAccountForm(true);
  }
  const closeDeleteGLAccountForm = () => {
    setShowDeleteGLAccountForm(false);
    setSelectedGLAccount(null)
  }

  const deleteHandleGLAccountClick = (_data) => {
    setSelectedGLAccount(_data)
    openDeleteGLAccountForm();
  }

  const handleDeleteGLAccount = () => {
    setSalesInvoiceDetails(prev =>
      prev.filter(
        item => item.deliveryOrderId !== selectedGLAccount?.deliveryOrderId
      )
    );
  };

  const actionsGLAccount = [
    { 
      name: "Edit", 
      tooltip: "edit",
      icon: <EditIcon fontSize="small" />,
      className: "bg-green-500 hover:bg-green-600",
      function: editHandleGLAccountClick,
      visible: true,
    },
    { 
      name: "Delete", 
      tooltip: "delete",
      icon: <DeleteForeverIcon fontSize="small" />,
      className: "bg-red-500 hover:bg-red-600",
      function: deleteHandleGLAccountClick,
      visible: true,
    },
  ];

  useEffect(() => {
    if(visible){
      const _totalSalesInvoiceAmount = salesInvoiceDetails?.reduce((acc, item) => acc + (Number(item.totalAmount) || 0), 0) || 0;
      setSubTotal(_totalSalesInvoiceAmount)
      setTotalAmount(_totalSalesInvoiceAmount)
    }
  }, [salesInvoiceDetails, setSubTotal, setTotalAmount, visible])
//#endregion 






  const handleFileChange = async (e) => {
    const fileData = await HandleFileUpload(e);

    if (fileData) {
      setUploadedFile(fileData);
    }
  };







  if (!visible) return null;

  return (
    <>
      <AnimatePresence>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 bg-slate-900/50 backdrop-blur-sm flex items-center justify-center z-50 p-4"
        >
          <motion.div
            initial={{ scale: 0.95, opacity: 0, y: 20 }}
            animate={{ scale: 1, opacity: 1, y: 0 }}
            exit={{ scale: 0.95, opacity: 0, y: 20 }}
            className="bg-gray-100 rounded-2xl shadow-2xl w-full max-w-7xl overflow-hidden flex flex-col max-h-[90vh]"
          >
            {/* Header */}
            <div className="px-8 py-5 bg-white border-b border-gray-200 flex justify-between items-center">
              <div>
                <h2 className="text-2xl font-bold text-gray-800 tracking-tight">{modalName}</h2>
                <p className="text-sm text-gray-500">Enter the transaction details below</p>
              </div>
              <button onClick={closeModal} className="text-gray-400 hover:text-gray-600 transition p-2 hover:bg-gray-100 rounded-full">
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>

            {/* Body */}
            <div className="p-8 overflow-y-auto custom-scrollbar">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {/* Related Parties */}
                <>
                  <div className="space-y-4 md:col-span-2 mt-2">
                    <h3 className="text-xs font-bold uppercase tracking-wider text-gray-400 border-b pb-1">Related Parties</h3>
                  </div>

                  {isEditable ?
                    <div>
                      <label className="block text-sm font-semibold mb-1 text-gray-700">
                        Customer <span className="text-red-500">*</span>
                      </label>
                      <div className="flex flex-row items-center">
                        <input
                          type="text"
                          placeholder="Select Customer"
                          className="w-full border border-gray-300 text-sm rounded-l-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color focus:border-theme-color transition"
                          value={`${customer ? `${customer?.customerId} - ${customer?.name1}` : ""}`}
                          readOnly
                        />
                        {!customer ?
                          <button className="bg-theme-color hover:bg-theme-color-h p-[5px] rounded-r-lg" onClick={openCustomerSelectForm}>
                            <PersonSearchIcon className="text-white"/>
                          </button> 
                          :
                          <button className="bg-red-400 hover:bg-red-500 p-[5px] rounded-r-lg" onClick={()=>setCustomer(null)}>
                            <RemoveCircleIcon className="text-white"/>
                          </button>
                        }
                      </div>
                    </div>
                    :
                    <div>
                      <label className="block text-sm font-semibold mb-1 text-gray-700">
                        Customer <span className="text-red-500">*</span>
                      </label>
                      <div className="flex flex-row items-center">
                        <input
                          type="text"
                          placeholder="Select Customer"
                          className="w-full border border-gray-300 text-sm rounded-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color focus:border-theme-color transition"
                          value={`${customer ? `${customer?.customerId} - ${customer?.name1}` : ""}`}
                          readOnly
                        />
                      </div>
                    </div>
                  }

                  <div>
                  </div>
                </>

                {/* Sales Invoice Details */}
                <>
                  <div className="space-y-4 md:col-span-2 mt-2">
                    <h3 className="text-xs font-bold uppercase tracking-wider text-gray-400 border-b pb-1">Sales Invoice Details</h3>
                  </div>
                  <div>
                    <label className="block text-sm font-semibold mb-1 text-gray-700">
                      Sales Invoice Number <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="text"
                      placeholder="e.g. INV-2023-001"
                      className="text-sm w-full border border-gray-300 rounded-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color transition"
                      value={salesInvoiceNumber}
                      onChange={(e) => setSalesInvoiceNumber(e.target.value)}
                      readOnly
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-semibold mb-1 text-gray-700">
                      Order Number
                    </label>
                    <input
                      type="text"
                      placeholder="e.g. INV-2023-001"
                      className="text-sm w-full border border-gray-300 rounded-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color transition"
                      value={orderNumber}
                      onChange={(e) => setOrderNumber(e.target.value)}
                      readOnly={!isEditable}
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-semibold mb-1 text-gray-700">
                      Sales Invoice Date  <span className="text-red-500">*</span>
                    </label>
                    <DateSelect data={salesInvoiceDate} setData={setSalesInvoiceDate} isEditable={isEditable}/>
                  </div>

                  <div>
                    <label className="block text-sm font-semibold mb-1 text-gray-700">
                      Due Date
                    </label>
                    <DateSelect data={dueDate} setData={setDueDate} isEditable={isEditable}/>
                  </div>
                  
                  <div>
                    <label className="block text-sm font-semibold mb-1 text-gray-700">
                      Billing Type <span className="text-red-500">*</span>
                    </label>
                    <BillingTypeSelect data={billingType} setData={setBillingType} isEditable={isEditable}/>
                  </div>

                  <div>
                    <label className="block text-sm font-semibold mb-1 text-gray-700">
                      Credit Term <span className="text-red-500">*</span>
                    </label>
                    <CreditTermSelect data={creditTerm} setData={setCreditTerm} isEditable={isEditable}/>
                  </div>

                  <div>
                    <label className="block text-sm font-semibold mb-1 text-gray-700">
                      (Dr) Account Receivable <span className="text-red-500">*</span>
                    </label>
                    <div className="flex flex-row items-center">
                      <input
                        type="text"
                        placeholder="Select Account"
                        className="w-full border border-gray-300 text-sm rounded-l-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color focus:border-theme-color transition"
                        value={account?.accountName || ""}
                        readOnly
                      />
                      {!account ?
                        <button className="bg-theme-color hover:bg-theme-color-h p-[5px] rounded-r-lg" onClick={openGLAccountSelectForm}>
                          <ManageSearchIcon className="text-white"/>
                        </button> 
                        :
                        <button className="bg-red-400 hover:bg-red-500 p-[5px] rounded-r-lg" onClick={()=>setAccount(null)}>
                          <RemoveCircleIcon className="text-white"/>
                        </button>
                      }
                    </div>
                  </div>
                </>

                {/* Sales Invoices Account */}
                <>
                  <div className="md:col-span-2 mt-4">
                    {/* Toggle Header Button */}
                    <button
                      type="button"
                      onClick={() => setShowSalesInvoices(!showSalesInvoices)}
                      className="flex items-center justify-between w-full border-b pb-2 group hover:border-theme-color transition-colors"
                    >
                      <div className="flex items-center gap-2">
                        <h3 className={`text-xs font-bold uppercase tracking-wider transition-colors ${showSalesInvoices ? 'text-theme-color' : 'text-gray-400'}`}>
                          Delivery Orders
                        </h3>
                        {/* Badge showing count */}
                        {salesInvoiceDetails?.length > 0 && (
                          <span className="bg-gray-200 text-gray-600 text-[10px] px-2 py-0.5 rounded-full font-bold">
                            {salesInvoiceDetails.length}
                          </span>
                        )}
                      </div>
                      
                      <div className={`transform transition-transform duration-300 text-gray-400 group-hover:text-theme-color ${showSalesInvoices ? "rotate-180" : ""}`}>
                        <ExpandMoreIcon /> 
                      </div>
                    </button>

                    {/* Expandable Content Area */}
                    <AnimatePresence>
                      {showSalesInvoices && (
                        <motion.div
                          initial={{ height: 0, opacity: 0 }}
                          animate={{ height: "auto", opacity: 1 }}
                          exit={{ height: 0, opacity: 0 }}
                          transition={{ duration: 0.3, ease: "easeInOut" }}
                          className="overflow-hidden"
                        >
                          <div className="py-5 space-y-5">
                            {/* Add button */}
                            <div className="flex gap-3 w-full justify-start">
                              {isEditable &&
                                <>
                                  {customer ? (
                                    <button
                                      type="button"
                                      onClick={openAddGLAccountForm}
                                      className="flex items-center gap-2 bg-theme-color text-white px-5 py-2 rounded-lg text-sm font-semibold hover:bg-theme-color-h transition shadow-md active:scale-95"
                                    >
                                      <AddCircleOutlineIcon fontSize="small" />
                                      New DO
                                    </button>
                                  ) : (
                                    <div className="flex items-center gap-2 bg-amber-50 border border-amber-200 text-amber-700 px-4 py-2 rounded-lg text-sm font-medium">
                                      <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-amber-500" viewBox="0 0 20 20" fill="currentColor">
                                        <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
                                      </svg>
                                      Please select a customer first to add an account
                                    </div>
                                  )}
                                </>
                              }
                            </div>

                            {/* List of Sales Invoices Account */}
                            <div className="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden">
                              <CreateTable
                                tableName={"SalesInvoice"}
                                headers={headersGLAccount}
                                accessors={accessorsGLAccount}
                                data={salesInvoiceDetails}
                                actions={actionsGLAccount}
                                currentPage={currentPageGLAccount}
                                setCurrentPage={setCurrentPageGLAccount}
                                itemsPerPage={10}
                                totalItems={salesInvoiceDetails?.length}
                              />
                            </div>

                            {salesInvoiceDetails.length > 0 && (
                              <div className="shadow-sm overflow-hidden gap-4 flex flex-col p-4 bg-gray-50">
                                {salesInvoiceDetails.map((doGroup) => {
                                  const doId = doGroup.deliveryOrderId;
                                  const isExpanded = !collapsedDOs[doId];

                                  return (
                                    <div key={doId} className="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden transition-all">
                                      <div 
                                        onClick={() => toggleDO(doId)} 
                                        className={`
                                          px-6 py-4 flex justify-between items-center cursor-pointer transition-all duration-200
                                          ${isExpanded ? 'bg-white border-b border-gray-200' : 'bg-gray-50/50 hover:bg-gray-100'}
                                        `}
                                      >
                                        {/* Left Side: DO Number & Icon */}
                                        <div className="flex items-center gap-3">
                                          <div className={`transition-transform duration-200 ${isExpanded ? 'rotate-180' : ''}`}>
                                              <ExpandMoreIcon className="text-gray-400" />
                                          </div>
                                          <div className="flex flex-col">
                                            <span className="text-[10px] uppercase font-bold text-gray-400 tracking-wider leading-none">Delivery Order</span>
                                            <span className="text-sm font-bold text-theme-color uppercase tracking-tight">
                                              {doGroup.deliveryOrderDONumber ?? "DO-UNKNOWN"}
                                            </span>
                                          </div>
                                        </div>

                                        {/* Right Side: Total Amount */}
                                        <div className="flex items-center gap-6">
                                          <div className="text-right">
                                            <span className="block text-[10px] uppercase font-bold text-gray-400 leading-none mb-1">Total Amount</span>
                                            <span className="text-sm font-mono font-bold text-gray-900">
                                              {`${getCurrency?.symbol ? getCurrency?.symbol : ""}${FormatValueToDecimal(doGroup.totalAmount)}`}
                                            </span>
                                          </div>
                                        </div>
                                      </div>

                                      {isExpanded && (
                                        <div className="overflow-x-auto animate-in fade-in slide-in-from-top-1">
                                          <table className="w-full text-left border-collapse">
                                            <thead>
                                              <tr className="bg-white border-b border-gray-100">
                                                <th className="px-6 py-3 text-[11px] font-bold text-gray-500 uppercase tracking-wider">Item Details</th>
                                                <th className="px-6 py-3 text-[11px] font-bold text-gray-500 uppercase tracking-wider w-24 text-center">Qty</th>
                                                <th className="px-6 py-3 text-[11px] font-bold text-gray-500 uppercase tracking-wider w-32 text-center font-mono">Price</th>
                                                <th className="px-6 py-3 text-[11px] font-bold text-gray-500 uppercase tracking-wider w-64">Cost of Goods (Dr)</th>
                                                <th className="px-6 py-3 text-[11px] font-bold text-gray-500 uppercase tracking-wider w-64">Inventory (Cr)</th>
                                              </tr>
                                            </thead>
                                            <tbody className="divide-y divide-gray-50">
                                              {doGroup?.deliveryOrder?.deliveryOrderDetailLines?.map((line) => {
                                                const selection = lineItemSelections.find(item => item.lineItemId === line.id) || {};
                                                const drAccount = selection.debitAccount;
                                                const crAccount = selection.creditAccount;

                                                return (
                                                  <tr key={line.id} className="hover:bg-gray-50/50">
                                                    <td className="px-6 py-4">
                                                      <div className="text-sm font-bold text-gray-900">{line.itemDescription}</div>
                                                      <div className="text-[11px] text-gray-400 font-mono">{line.itemCode}</div>
                                                    </td>
                                                    <td className="px-6 py-4 text-center text-sm">{line.receivedQty}</td>
                                                    <td className="px-6 py-4 text-center text-sm font-mono font-bold">
                                                      {`${getCurrency?.symbol ? getCurrency?.symbol : ""}${FormatValueToDecimal(line?.unitPrice)}`}
                                                      
                                                    </td>

                                                    {/* DEBIT ACCOUNT (DR) */}
                                                    <td className="px-6 py-4">
                                                      <div className="flex flex-row items-center">
                                                        <input
                                                          type="text"
                                                          placeholder="Select Dr Account"
                                                          className="w-full border border-gray-300 text-[12px] rounded-l-lg px-3 py-2 bg-gray-50 font-medium min-w-[150px]"
                                                          value={drAccount ? `${drAccount.accountNumber} - ${drAccount.accountName}` : ""}
                                                          readOnly
                                                        />
                                                        {!drAccount ? (
                                                          <button onClick={() => { 
                                                            setActiveTarget({ lineId: line.id, side: 'dr' }); 
                                                            openLineItemDrAccountSelectForm(); }}
                                                            className="bg-theme-color hover:bg-theme-color-h p-[5px] rounded-r-lg"
                                                          >
                                                              <ManageSearchIcon className="text-white !text-sm"/>
                                                          </button> 
                                                        ) : (
                                                          <button onClick={() => handleRemoveAccount(line.id, 'debitAccount')}
                                                            className="bg-red-400 hover:bg-red-500 p-[5px] rounded-r-lg"
                                                          >
                                                              <RemoveCircleIcon className="text-white !text-sm"/>
                                                          </button>
                                                        )}
                                                      </div>
                                                    </td>

                                                    {/* CREDIT ACCOUNT (CR) */}
                                                    <td className="px-6 py-4">
                                                      <div className="flex flex-row items-center">
                                                        <input
                                                          type="text"
                                                          placeholder="Select Cr Account"
                                                          className="w-full border border-gray-300 text-[12px] rounded-l-lg px-3 py-2 bg-gray-50 font-medium min-w-[150px]"
                                                          value={crAccount ? `${crAccount.accountNumber} - ${crAccount.accountName}` : ""}
                                                          readOnly
                                                        />
                                                        {!crAccount ? (
                                                          <button onClick={() => { 
                                                            setActiveTarget({ lineId: line.id, side: 'cr' }); 
                                                            openLineItemCrAccountSelectForm(); }}
                                                            className="bg-theme-color hover:bg-theme-color-h p-[5px] rounded-r-lg"
                                                          >
                                                              <ManageSearchIcon className="text-white !text-sm"/>
                                                          </button> 
                                                        ) : (
                                                          <button onClick={() => handleRemoveAccount(line.id, 'creditAccount')}
                                                            className="bg-red-400 hover:bg-red-500 p-[5px] rounded-r-lg"
                                                          >
                                                              <RemoveCircleIcon className="text-white !text-sm"/>
                                                          </button>
                                                        )}
                                                      </div>
                                                    </td>
                                                  </tr>
                                                );
                                              })}
                                            </tbody>
                                          </table>
                                        </div>
                                      )}
                                    </div>
                                  );
                                })}
                              </div>
                            )}
                          </div>
                        </motion.div>
                      )}
                    </AnimatePresence>

                    {/* Summary when collapsed (Optional) */}
                    {!showSalesInvoices && salesInvoiceDetails?.length > 0 && (
                      <motion.p 
                        initial={{ opacity: 0 }} 
                        animate={{ opacity: 1 }} 
                        className="text-[11px] text-gray-400 mt-2 italic"
                      >
                        Click to view {salesInvoiceDetails.length} salesInvoice line items...
                      </motion.p>
                    )}
                  </div>

                  {/* ADjustments */}
                  <div className="hidden">
                    <div className="space-y-4 md:col-span-2 mt-2">
                      <h3 className="text-xs font-bold uppercase tracking-wider text-gray-400 border-b pb-1">Adjustments</h3>
                    </div>

                    <div>
                      <label className="block text-sm font-semibold mb-1 text-gray-700">
                        VAT (%)
                      </label>
                      <input
                        type="number"
                        placeholder="0"
                        className="text-sm w-full border border-gray-300 rounded-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color transition"
                        value={vat}
                        onChange={(e) => setVAT(e.target.value)}
                        readOnly={!isEditable}
                      />
                      <div className="mt-2 flex items-center gap-2 bg-amber-50 border border-amber-200 text-amber-700 px-4 py-2 rounded-lg text-sm font-medium">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-amber-500" viewBox="0 0 20 20" fill="currentColor">
                          <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
                        </svg>
                        {`${FormatValueToDecimal(vat || 0)} % - (${getCurrency?.symbol ?? ""} ${FormatValueToDecimal(vatAmount || 0)})`}
                      </div>
                    </div>

                    <div>
                      <label className="block text-sm font-semibold mb-1 text-gray-700">
                        Discounts (%)
                      </label>
                      <input
                        type="number"
                        placeholder="0"
                        className="text-sm w-full border border-gray-300 rounded-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color transition"
                        value={discounts}
                        onChange={(e) => setDiscounts(e.target.value)}
                        readOnly={!isEditable}
                      />
                      <div className="mt-2 flex items-center gap-2 bg-amber-50 border border-amber-200 text-amber-700 px-4 py-2 rounded-lg text-sm font-medium">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-amber-500" viewBox="0 0 20 20" fill="currentColor">
                          <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
                        </svg>
                        {`${FormatValueToDecimal(discounts || 0)} % - (${getCurrency?.symbol ?? ""} ${FormatValueToDecimal(discountAmount || 0)})`}
                      </div>
                    </div>

                    <div className="hidden">
                      <label className="block text-sm font-semibold mb-1 text-gray-700">
                        Zero Rated (%)
                      </label>
                      <input
                        type="number"
                        placeholder="0"
                        className="text-sm w-full border border-gray-300 rounded-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color transition"
                        value={zeroRated}
                        onChange={(e) => setZeroRated(e.target.value)}
                        readOnly={!isEditable}
                      />
                      <div className="mt-2 flex items-center gap-2 bg-amber-50 border border-amber-200 text-amber-700 px-4 py-2 rounded-lg text-sm font-medium">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-amber-500" viewBox="0 0 20 20" fill="currentColor">
                          <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
                        </svg>
                        {`${FormatValueToDecimal(zeroRated || 0)} % - (${getCurrency?.symbol ?? ""} ${FormatValueToDecimal(zeroRatedAmount || 0)})`}
                      </div>
                    </div>

                    <div>
                      <label className="block text-sm font-semibold mb-1 text-gray-700">
                        EWT (%)
                      </label>
                      <input
                        type="number"
                        placeholder="0"
                        className="text-sm w-full border border-gray-300 rounded-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color transition"
                        value={ewt}
                        onChange={(e) => setEWT(e.target.value)}
                        readOnly={!isEditable}
                      />
                      <div className="mt-2 flex items-center gap-2 bg-amber-50 border border-amber-200 text-amber-700 px-4 py-2 rounded-lg text-sm font-medium">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-amber-500" viewBox="0 0 20 20" fill="currentColor">
                          <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
                        </svg>
                        {`${FormatValueToDecimal(ewt || 0)} % - (${getCurrency?.symbol ?? ""} ${FormatValueToDecimal(ewtAmount || 0)})`}
                      </div>
                    </div>
                  </div>

                  <div className="md:col-span-2">
                    <div className="bg-white border border-gray-200 rounded-2xl p-6 shadow-sm flex flex-col md:flex-row justify-between items-center gap-4">
                      <div className="flex items-center gap-4">
                        <div className="bg-theme-color/10 p-3 rounded-xl">
                          <AccountBalanceWalletIcon className="text-theme-color" />
                        </div>
                        <div>
                          <p className="text-[11px] font-bold uppercase tracking-widest text-gray-400">
                            Total Transaction Amount
                          </p>
                          <p className="text-xs text-gray-500">
                            Sum of all salesInvoice line items above
                          </p>
                        </div>
                      </div>

                      <div className="text-center md:text-right">
                        <span className="text-[11px] font-bold uppercase tracking-widest text-gray-400">
                          {`Sub Total: ${getCurrency?.symbol ? getCurrency?.symbol : ""} ${FormatValueToDecimal(subTotal)}`}
                        </span>
                        <div className="flex items-baseline justify-center md:justify-end gap-2">
                          <span className="text-3xl font-black text-gray-800 tracking-tight">
                            {`${getCurrency?.symbol ? getCurrency?.symbol : ""} ${FormatValueToDecimal(totalAmount)}`}
                          </span>
                        </div>
                        {/* Visual indicator of validation */}
                        {totalAmount > 0 ? (
                          <span className="text-[10px] font-bold text-green-500 bg-green-50 px-2 py-0.5 rounded-full uppercase tracking-tighter">
                            ● Ready to Save
                          </span>
                        ) : (
                          <span className="text-[10px] font-bold text-amber-500 bg-amber-50 px-2 py-0.5 rounded-full uppercase tracking-tighter">
                            ○ No amount detected
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                </>

                {/* Full Width: Notes */}
                <div className="md:col-span-2">
                  <label className="block text-sm font-semibold mb-1 text-gray-700">
                    Notes
                  </label>
                  <textarea
                    rows="3"
                    placeholder="Enter any additional details or remarks..."
                    className="text-sm w-full border border-gray-300 rounded-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color transition"
                    value={notes}
                    onChange={(e) => setNotes(e.target.value)}
                    readOnly={!isEditable}
                  />
                </div>
              </div>
              
              <div className="mt-6 space-y-2">
                <label className="text-[11px] font-bold uppercase tracking-widest text-gray-400 ml-1">Attachment</label>
                
                <div className={`relative group transition-all duration-200 rounded-xl border-2 border-dashed 
                  ${uploadedFile ? 'border-theme-color/30 bg-theme-color/5' : 'border-gray-200 hover:border-theme-color/50 bg-gray-50/50 hover:bg-white'}`}>
                  
                  {/* Hidden Input - clickable over the whole area */}
                  {isEditable && (
                    <input
                      type="file"
                      onChange={handleFileChange}
                      className="absolute inset-0 w-full h-full opacity-0 cursor-pointer z-10"
                    />
                  )}

                  <div className="p-4 flex items-center justify-between gap-4">
                    <div className="flex items-center gap-3">
                      {/* Icon based on state */}
                      <div className={`p-2.5 rounded-lg ${uploadedFile ? 'bg-theme-color text-white' : 'bg-gray-200 text-gray-500'}`}>
                        {uploadedFile ? (
                          <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                          </svg>
                        ) : (
                          <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" />
                          </svg>
                        )}
                      </div>

                      <div>
                        <p className={`text-sm font-semibold truncate max-w-[200px] ${uploadedFile ? 'text-gray-800' : 'text-gray-500'}`}>
                          {uploadedFile ? uploadedFile.fileName : "Click to upload file"}
                        </p>
                        <p className="text-[11px] text-gray-400 font-medium">
                          {uploadedFile ? (uploadedFile.contentType || "Document") : "Support any file format"}
                        </p>
                      </div>
                    </div>

                    {/* Action Button */}
                    {uploadedFile && (
                      <button
                        type="button"
                        onClick={(e) => { e.stopPropagation(); DownloadFile(uploadedFile); }}
                        className="relative z-20 flex items-center gap-2 px-4 py-2 text-xs font-bold text-theme-color bg-white border border-theme-color/20 rounded-lg shadow-sm hover:bg-theme-color hover:text-white transition-all"
                      >
                        <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
                        </svg>
                        DOWNLOAD
                      </button>
                    )}
                  </div>
                </div>
                
                {!uploadedFile && <p className="text-[10px] text-gray-400 italic ml-1">* No file attached yet</p>}
              </div>

            </div>

            {/* Footer */}
            <div className="px-8 py-6 border-t bg-white flex justify-end items-center space-x-4">
              <button
                onClick={closeModal}
                className="px-6 py-2.5 rounded-lg border border-gray-300 text-gray-600 hover:bg-gray-50 transition font-semibold text-sm"
              >
                Cancel
              </button>
              {isEditable &&
                <button
                  onClick={handleSubmit}
                  className="px-10 py-2.5 rounded-lg bg-theme-color text-white font-bold hover:opacity-90 shadow-lg shadow-theme-color/20 transition active:scale-95 text-sm"
                >
                  Save Transaction
                </button>
              }
            </div>
          </motion.div>
        </motion.div>
      </AnimatePresence>
      
      <CustomerSelect 
        visible={showCustomerSelectForm} 
        onClose={closeCustomerSelectForm}
        modalName={"Select Customer"}
        data={customer} setData={setCustomer}
      />

      {/* <DrAccountsReceivablesChartOfAccountsSelect  */}
      <ChartOfAccountsSelect 
        visible={showGLAccountSelectForm} 
        onClose={closeGLAccountSelectForm}
        modalName={"Select Account"}
        data={account} setData={setAccount}
      />

      <ChartOfAccountsSelect 
        visible={showLineItemAccountDrSelectForm || showLineItemAccountCrSelectForm} 
        onClose={() => {
            closeLineItemDrAccountSelectForm();
            closeLineItemCrAccountSelectForm();
        }}
        modalName={"Select Account"}
        data={tempAccount} 
        setData={setTempAccount}
      />

      <AddUpdateGLAccountModal 
        visible={showAddGLAccountForm} 
        onClose={closeAddGLAccountForm}
        modalName={"Add Sales Invoice Account"}
        data={selectedGLAccount}
        salesInvoiceDetails={salesInvoiceDetails} setSalesInvoiceDetails={setSalesInvoiceDetails}
        customer={customer}
      />

      <AddUpdateGLAccountModal 
        visible={showUpdateGLAccountForm} 
        onClose={closeUpdateGLAccountForm}
        modalName={"Update Sales Invoice Account"}
        data={selectedGLAccount}
        salesInvoiceDetails={salesInvoiceDetails} setSalesInvoiceDetails={setSalesInvoiceDetails}
        customer={customer}
      />

      <ConfirmationModal 
        visible={showDeleteGLAccountForm} 
        onClose={closeDeleteGLAccountForm} 
        onSave={handleDeleteGLAccount} 
        modalName={"Delete"} 
        message={`Do you want to remove this account [ ${selectedGLAccount?.deliveryOrderDONumber} ]?.`}
      />

      <div className="fixed top-5 right-5 z-50 flex flex-col space-y-2">
        <FailMessage message={failMessage} onClose={() => setFailMessage("")} />
      </div>
    </>
  );
};
const ViewModal = ({
  visible, onClose, onSave, modalName,
  salesInvoiceDetails, setSalesInvoiceDetails,
  customer, setCustomer,
  salesInvoiceNumber, setSalesInvoiceNumber,
  orderNumber, setOrderNumber,
  account, setAccount,
  salesInvoiceDate, setSalesInvoiceDate,
  dueDate, setDueDate,
  billingType, setBillingType,
  creditTerm, setCreditTerm,
  totalAmount, setTotalAmount,
  amountPaid, setAmountPaid,
  vat, setVAT,
  discounts, setDiscounts,
  zeroRated, setZeroRated,
  ewt, setEWT,
  subTotal, setSubTotal,
  status, setStatus,
  notes, setNotes,
  uploadedFile, setUploadedFile,
  creditNotesAmount, setCreditNotesAmount,
  isEditable
}) => {
  const getCurrency = JSON.parse(localStorage.getItem("currency") || "{}");
  const printRef = useRef();
  const [isDownloading, setIsDownloading] = useState(false);

  //#region Adjustments
  const [vatAmount, setVATAmount] = useState(0);
  const [discountAmount, setDiscountAmount] = useState(0);
  const [zeroRatedAmount, setZeroRatedAmount] = useState(0);
  const [ewtAmount, setEWTAmount] = useState(0);

  /* useEffect(() => {
    if (subTotal > 0 && visible) {
      // VAT
      const _vatPercent = vat / 100;

      // Discount
      const _discountPercent = discounts / 100;
      const _discountAmount = subTotal * _discountPercent;

      // Zero Rated
      const _zeroRatedPercent = zeroRated / 100;
      const _zeroRatedAmount = subTotal * _zeroRatedPercent;

      // VAT adjusted for Zero-Rated
      const _vatAmount = (subTotal - _discountAmount - _zeroRatedAmount) * _vatPercent;

      // EWT
      const _ewtPercent = ewt / 100;
      const _ewtAmount = (subTotal - _discountAmount) * _ewtPercent;

      // Set state
      setDiscountAmount(_discountAmount);
      setZeroRatedAmount(_zeroRatedAmount);
      setVATAmount(_vatAmount);
      setEWTAmount(_ewtAmount);

      // Compute total using freshly computed values
      const _totalAmount = subTotal - _discountAmount + _vatAmount - _ewtAmount;
      setTotalAmount(_totalAmount);
    }
  }, [setTotalAmount, subTotal, vat, discounts, zeroRated, ewt, visible]); */

  const resetLocalVariables = () => {
    setVATAmount(0);
    setDiscountAmount(0);
    setZeroRatedAmount(0);
    setEWTAmount(0);
  }
//#endregion


  // Helper for currency formatting
  const formatVal = (num) => {
    return typeof FormatValueToDecimal === "function" 
      ? FormatValueToDecimal(num) 
      : Number(num || 0).toLocaleString(undefined, { minimumFractionDigits: 2 });
  };

  const downloadHandleClick = async () => {
    const element = printRef.current;
    if (!element) return;

    setIsDownloading(true);
    try {
      const canvas = await html2canvas(element, {
        scale: 2,
        useCORS: true,
        logging: false,
        backgroundColor: "#ffffff",
        windowWidth: 1200,
        windowHeight: element.scrollHeight
      });

      const imgData = canvas.toDataURL('image/png');
      const pdf = new jsPDF({
        orientation: 'portrait',
        unit: 'mm',
        format: 'a4'
      });

      const imgWidth = 210;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;

      pdf.addImage(imgData, 'PNG', 0, 0, imgWidth, imgHeight);
      pdf.save(`SalesInvoice_${'Export'}.pdf`);
    } catch (error) {
      console.error("PDF Generation Error:", error);
    } finally {
      setIsDownloading(false);
    }
  };

  const handleSubmit = async () => {
    await downloadHandleClick();
  };

  const closeModal = () => {
    resetLocalVariables();
    onClose();
  };

  if (!visible) return null;

  return (
    <>
      <AnimatePresence>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 bg-slate-900/50 backdrop-blur-sm flex items-center justify-center z-50 p-4"
        >
          <motion.div
            initial={{ scale: 0.95, opacity: 0, y: 20 }}
            animate={{ scale: 1, opacity: 1, y: 0 }}
            exit={{ scale: 0.95, opacity: 0, y: 20 }}
            className="bg-gray-100 rounded-2xl shadow-2xl w-full max-w-7xl overflow-hidden flex flex-col max-h-[90vh]"
          >
            {/* Header */}
            <div className="px-8 py-5 bg-white border-b border-gray-200 flex justify-between items-center">
              <div>
                <h2 className="text-2xl font-bold text-gray-800 tracking-tight">{modalName}</h2>
                <p className="text-sm text-gray-500">Enter the transaction details below</p>
              </div>
              <button onClick={closeModal} className="text-gray-400 hover:text-gray-600 transition p-2 hover:bg-gray-100 rounded-full">
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>

            {/* Body */}
            <div className="p-8 overflow-y-auto custom-scrollbar">
              <div
                ref={printRef}
                className="max-w-4xl mx-auto bg-white shadow-xl border border-gray-200 rounded-sm p-12 min-h-[800px] flex flex-col"
              >
                {/* 1. Header Section */}
                <div className="flex justify-between items-start border-b-4 border-theme-color pb-8 mb-10">
                  <div>
                    <h1 className="text-4xl font-black text-theme-color tracking-tighter mb-2">SALES INVOICE</h1>
                    <div className="flex items-center gap-3">
                      <span className={`px-3 py-1 rounded-full text-[10px] font-bold uppercase tracking-wider ${
                        status === 'Paid' ? 'bg-green-100 text-green-700' : 'bg-amber-100 text-amber-700'
                      }`}>
                        {status || 'Unpaid'}
                      </span>
                      <span className="text-xs font-semibold text-gray-400">Type: {billingType.description || 'Standard'}</span>
                    </div>
                    <div className="flex items-center gap-3 mt-2">
                      <span className="text-xs font-semibold text-gray-400">{account?.accountName || 'N/A'}</span>
                    </div>
                  </div>
                  <div className="text-right">
                    <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest">Sales Invoice Number</p>
                    <p className="text-2xl font-mono font-bold text-theme-color">#{salesInvoiceNumber || '---'}</p>
                    <div className="mt-4 grid grid-cols-2 gap-4 text-right">
                      <div>
                        <p className="text-[9px] font-bold text-gray-400 uppercase">Sales Invoice Date</p>
                        <p className="text-xs font-bold text-gray-800">{salesInvoiceDate ? new Date(salesInvoiceDate).toLocaleDateString() : 'N/A'}</p>
                      </div>
                      <div>
                        <p className="text-[9px] font-bold text-gray-400 uppercase">Due Date</p>
                        <p className="text-xs font-bold text-red-600">{dueDate ? new Date(dueDate).toLocaleDateString() : 'N/A'}</p>
                      </div>
                    </div>
                  </div>
                </div>

                {/* 2. Customer & Terms Section */}
                <div className="grid grid-cols-3 gap-8 mb-12">
                  <div className="col-span-1 space-y-3">
                    <h3 className="text-[11px] font-bold text-theme-color uppercase tracking-[0.2em] border-b border-gray-100 pb-2">Customer (Received from)</h3>
                    {customer ? (
                      <div>
                        <p className="font-bold text-gray-900 text-lg leading-tight">{customer.name1 || customer.Name1}</p>
                        <p className="text-sm text-gray-500">{customer.name2 || customer.Name2}</p>
                        <p className="text-xs text-gray-400 mt-2 font-mono">ID: {customer.customerId || customer.CustomerId}</p>
                      </div>
                    ) : (
                      <p className="text-sm italic text-gray-400">No customer details</p>
                    )}
                  </div>

                  <div className="col-span-2 grid grid-cols-2 gap-4 bg-gray-50 p-6 rounded-xl border border-gray-100 h-fit">
                    <div>
                      <p className="text-[10px] font-bold text-gray-400 uppercase mb-1">Order Number</p>
                      <p className="text-sm font-bold text-gray-700">{orderNumber || 'N/A'}</p>
                    </div>
                    <div>
                      <p className="text-[10px] font-bold text-gray-400 uppercase mb-1">Credit Terms</p>
                      <p className="text-sm font-bold text-gray-700">{creditTerm?.description || 'N/A'}</p>
                    </div>
                  </div>
                </div>

                {/* 3. Sales Invoice Accounts / Items Table */}
                <div className="flex-grow">
                  <table className="w-full">
                    <thead>
                      <tr className="bg-theme-color text-white">
                        <th className="py-3 px-4 text-left text-[10px] font-bold uppercase tracking-widest">Account / PO Ref</th>
                        <th className="py-3 px-4 text-right text-[10px] font-bold uppercase tracking-widest">Subtotal</th>
                        <th className="py-3 px-4 text-right text-[10px] font-bold uppercase tracking-widest hidden">Tax/Disc</th>
                        <th className="py-3 px-4 text-right text-[10px] font-bold uppercase tracking-widest">Discount</th>
                        <th className="py-3 px-4 text-right text-[10px] font-bold uppercase tracking-widest">Total</th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-100 border-b border-gray-200">
                      {salesInvoiceDetails?.length > 0 ? (
                        salesInvoiceDetails.map((item, idx) => (
                          <tr key={idx} className="hover:bg-gray-50/50 transition-colors">
                            <td className="py-5 px-4">
                              <p className="text-sm font-bold text-gray-800">{item.glAccountName || 'General Account'}</p>
                              <p className="text-[10px] text-theme-color font-semibold uppercase">SO: {item.deliveryOrderDONumber || 'N/A'}</p>
                            </td>
                            <td className="py-5 px-4 text-right text-sm font-medium text-gray-600">
                              {getCurrency?.symbol} {formatVal(item.subTotal)}
                            </td>
                            <td className="py-5 px-4 text-right text-sm font-medium text-gray-500 hidden">
                              <div className="text-[10px]">T: {formatVal(item.taxAmount)}</div>
                              <div className="text-[10px] text-red-400">D: {formatVal(item.totalDiscount)}</div>
                            </td>
                            <td className="py-5 px-4 text-right text-sm font-medium text-gray-500">
                              <div className="text-red-400">{getCurrency?.symbol} {formatVal(item.totalDiscount)}</div>
                            </td>
                            <td className="py-5 px-4 text-right text-sm font-bold text-gray-900">
                              {getCurrency?.symbol} {formatVal(item.totalAmount)}
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="4" className="py-10 text-center text-sm text-gray-400 italic">No salesInvoice accounts linked</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>

                {/* 4. Totals Section */}
                <div className="mt-10 flex justify-between items-start gap-12">
                  <div className="flex-1">
                    <h4 className="text-[10px] font-black text-gray-900 uppercase tracking-widest mb-2">Remarks / Notes</h4>
                    <p className="text-xs text-gray-500 leading-relaxed bg-gray-50 p-4 rounded-lg border border-dashed border-gray-200 min-h-[80px]">
                      {notes || "No additional instructions provided."}
                    </p>

                    {/* Attachment Card */}
                    {uploadedFile && (
                      <div className="mt-4 inline-flex items-center gap-3 p-3 border border-gray-100 rounded-lg bg-white shadow-sm">
                        <div className="p-2 bg-theme-color/10 text-theme-color rounded">
                          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15.172 7l-6.586 6.586a2 2 0 102.828 2.828l6.414-6.586a4 4 0 00-5.656-5.656l-6.415 6.585a6 6 0 108.486 8.486L20.5 13" />
                          </svg>
                        </div>
                        <div className="pr-4">
                          <p className="text-[10px] font-bold text-gray-800 leading-none">{uploadedFile.fileName || 'Attachment'}</p>
                          <p className="text-[8px] text-gray-400 uppercase mt-1">Verified File</p>
                        </div>
                      </div>
                    )}
                  </div>

                  <div className="w-72 space-y-2">

                    {/* Subtotal */}
                    <div className="flex justify-between text-sm">
                      <span className="text-gray-400 font-medium">Subtotal</span>
                      <span className="text-gray-700 font-semibold">
                        {getCurrency?.symbol} {formatVal(subTotal)}
                      </span>
                    </div>


                    <div className="hidden">
                      {/* Discount */}
                      {discountAmount > 0 && (
                        <div className="flex justify-between text-sm">
                          <span className="text-red-400 font-medium">
                            Discount ({discounts}%)
                          </span>
                          <span className="text-red-500 font-semibold">
                            -{getCurrency?.symbol} {formatVal(discountAmount)}
                          </span>
                        </div>
                      )}

                      {/* Zero Rated */}
                      {zeroRatedAmount > 0 && (
                        <div className="flex justify-between text-sm">
                          <span className="text-gray-400 font-medium">
                            Zero Rated ({zeroRated}%)
                          </span>
                          <span className="text-gray-600 font-semibold">
                            {getCurrency?.symbol} {formatVal(zeroRatedAmount)}
                          </span>
                        </div>
                      )}

                      {/* VAT */}
                      {vatAmount > 0 && (
                        <div className="flex justify-between text-sm">
                          <span className="text-gray-400 font-medium">
                            VAT ({vat}%)
                          </span>
                          <span className="text-gray-700 font-semibold">
                            {getCurrency?.symbol} {formatVal(vatAmount)}
                          </span>
                        </div>
                      )}

                      {/* EWT */}
                      {ewtAmount > 0 && (
                        <div className="flex justify-between text-sm">
                          <span className="text-blue-400 font-medium">
                            EWT ({ewt}%)
                          </span>
                          <span className="text-blue-600 font-semibold">
                            -{getCurrency?.symbol} {formatVal(ewtAmount)}
                          </span>
                        </div>
                      )}
                    </div>

                    <div className="border-t border-gray-200 my-2 hidden"></div>

                    <div className="hidden justify-between text-sm">
                      <span className="text-gray-400 font-medium"></span>
                      <span className="text-gray-700 font-semibold">
                        {getCurrency?.symbol} {formatVal(totalAmount)}
                      </span>
                    </div>

                    <div className="flex justify-between text-sm">
                      <span className="text-gray-400 font-medium">Credit Amount</span>
                      <span className="text-gray-700 font-semibold">
                        -{getCurrency?.symbol} {formatVal(creditNotesAmount)}
                      </span>
                    </div>

                    {/* Total Amount */}
                    <div className="flex justify-between text-sm">
                      <span className="text-gray-700 font-bold">Total Amount</span>
                      <span className="text-gray-900 font-bold">
                        {getCurrency?.symbol} {formatVal(totalAmount - creditNotesAmount)}
                      </span>
                    </div>

                    {/* Amount Received */}
                    <div className="flex justify-between text-sm">
                      <span className="text-gray-400 font-medium">Amount Received</span>
                      <span className="text-green-600 font-bold">
                        -{getCurrency?.symbol} {formatVal(amountPaid)}
                      </span>
                    </div>

                    {/* Balance Due */}
                    <div className="flex justify-between items-center pt-4 border-t-2 border-theme-color">
                      <span className="text-xs font-black text-gray-900 uppercase">
                        Balance Due
                      </span>
                      <span className="text-3xl font-black text-theme-color tracking-tighter">
                        {getCurrency?.symbol} {formatVal((totalAmount - creditNotesAmount) - (amountPaid || 0))}
                      </span>
                    </div>

                    {/* Available Credit */}
                    <div className="justify-between text-sm italic hidden">
                      <span className="text-blue-400 font-medium">Available Credit</span>
                      <span className="text-blue-600 font-semibold">
                        {getCurrency?.symbol} {formatVal(creditNotesAmount)}
                      </span>
                    </div>

                  </div>

                </div>
              </div>
            </div>

            {/* Footer Buttons */}
            <div className="px-8 py-6 border-t bg-white flex justify-end items-center space-x-4">
              <button
                onClick={closeModal}
                className="px-6 py-2.5 rounded-lg border border-gray-300 text-gray-600 hover:bg-gray-50 transition font-semibold text-sm"
              >
                Cancel
              </button>
              <button
                onClick={handleSubmit}
                disabled={isDownloading}
                className={`px-10 py-2.5 rounded-lg bg-theme-color text-white font-bold shadow-lg shadow-theme-color/20 transition active:scale-95 text-sm flex items-center gap-2 ${isDownloading ? 'opacity-70 cursor-not-allowed' : 'hover:opacity-90'}`}
              >
                {isDownloading ? (
                    <>
                      <svg className="animate-spin h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle><path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path></svg>
                      Generating PDF...
                    </>
                ) : 'Download PDF'}
              </button>
            </div>
          </motion.div>
        </motion.div>
      </AnimatePresence>
    </>
  );
};
//#endregion








//#region Sales Invoice Account
const AddUpdateGLAccountModal = ({
  visible, onClose, onSave, modalName,
  data,
  salesInvoiceDetails, setSalesInvoiceDetails,
  customer
}) => {
  const getCurrency = JSON.parse(localStorage.getItem("currency") || "{}");

  const [loading, setLoading] = useState(false);
  const [failMessage, setFailMessage] = useState("");
  const [glAccount, setGLAccount] = useState(null);
  const [deliveryOrder, setDeliveryOrder] = useState(null);

  const [showGLAccountSelectForm, setShowGLAccountSelectForm] = useState(false);
  const openGLAccountSelectForm = () => {
    setShowGLAccountSelectForm(true);
  }
  const closeGLAccountSelectForm = () => {
    setShowGLAccountSelectForm(false);
  }

  const [showDeliveryOrderSelectForm, setShowDeliveryOrderSelectForm] = useState(false);
  const openDeliveryOrderSelectForm = () => {
    setShowDeliveryOrderSelectForm(true);
  }
  const closeDeliveryOrderSelectForm = () => {
    setShowDeliveryOrderSelectForm(false);
  }

  const fetchDataDOById = useCallback(async (_data) => {
    try {
      const response = await axios.get(`${apiUrl}/api/DeliveryOrder/${_data?.id}` , {
        headers: { 'Content-Type': 'application/json'}
      })
        
      return (response.data)
    } catch (error) {
      console.error('Error fetching data:', error);
      return null
    }
  }, []);

  const handleSubmit = async () => {
    // Logic updated to match your state requirements
    if (!glAccount) {
      setFailMessage("Please fill up all required fields (Sales Invoice Account, Paid Through, and Amount).");
      return;
    }

    if(modalName === "Add Sales Invoice Account"){
      const foundData = salesInvoiceDetails.find(i => i.deliveryOrderId === deliveryOrder.id)

      if (foundData) {
        setFailMessage("Already added this account.");
        return;
      }

      setLoading(true);

      const _deliveryOrder = await fetchDataDOById(deliveryOrder)

      const newData = {
        glAccountId: glAccount?.id,
        glAccountName: glAccount?.accountName,
        glAccount: glAccount,
        deliveryOrderId: deliveryOrder?.id,
        deliveryOrderDONumber: deliveryOrder?.doNumber,
        deliveryOrder: _deliveryOrder,
        subTotal: deliveryOrder?.subTotal,
        totalDiscount: deliveryOrder?.totalDiscount,
        taxAmount: deliveryOrder?.taxAmount,
        totalAmount: deliveryOrder?.totalAmount,
      }

      setSalesInvoiceDetails((prev) => [...prev, newData])
    }

    if(modalName === "Update Sales Invoice Account"){
      const foundData = salesInvoiceDetails.find(i => i.deliveryOrderId === deliveryOrder.id && data?.deliveryOrderId !== deliveryOrder.id)

      if (foundData) {
        setFailMessage("Already added this account.");
        return;
      }

      setLoading(true);

      const _deliveryOrder = await fetchDataDOById(deliveryOrder)

      const newData = {
        glAccountId: glAccount?.id,
        glAccountName: glAccount?.accountName,
        glAccount: glAccount,
        deliveryOrderId: deliveryOrder?.id,
        deliveryOrderDONumber: deliveryOrder?.doNumber,
        deliveryOrder: _deliveryOrder,
        subTotal: deliveryOrder?.subTotal,
        totalDiscount: deliveryOrder?.totalDiscount,
        taxAmount: deliveryOrder?.taxAmount,
        totalAmount: deliveryOrder?.totalAmount,
      }

      setSalesInvoiceDetails(prev =>
        prev.map(item =>
          item.deliveryOrderId === data?.deliveryOrderId
            ? newData
            : item
        )
      );
    }

    setLoading(false);
    closeModal();
  };

  const resetLocalVariables = () => {
    setGLAccount(null)
    setDeliveryOrder(null)
    setLoading(false)
  }

  const closeModal = () => {
    setFailMessage("");
    onClose();
    resetLocalVariables();
  };

  useEffect(() => {
    if(visible){
      setGLAccount(data?.glAccount ?? null)
      setDeliveryOrder(data?.deliveryOrder ?? null)
    }
  }, [visible, data])

  

  if (!visible) return null;

  return (
    <>
      <AnimatePresence>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 bg-slate-900/50 backdrop-blur-sm flex items-center justify-center z-50 p-4"
        >
          <motion.div
            initial={{ scale: 0.95, opacity: 0, y: 20 }}
            animate={{ scale: 1, opacity: 1, y: 0 }}
            exit={{ scale: 0.95, opacity: 0, y: 20 }}
            className="bg-gray-100 rounded-2xl shadow-2xl w-full max-w-5xl overflow-hidden flex flex-col max-h-[90vh]"
          >
            {/* Header */}
            <div className="px-8 py-5 bg-white border-b border-gray-200 flex justify-between items-center">
              <div>
                <h2 className="text-2xl font-bold text-gray-800 tracking-tight">{modalName}</h2>
                <p className="text-sm text-gray-500">Enter the transaction details below</p>
              </div>
              <button onClick={closeModal} className="text-gray-400 hover:text-gray-600 transition p-2 hover:bg-gray-100 rounded-full">
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>

            {/* Body */}
            <div className="p-8 overflow-y-auto custom-scrollbar">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <>
                  {/* --- Section 1: Entities --- */}
                  <div className="space-y-4 md:col-span-2 mt-2">
                    <h3 className="text-xs font-bold uppercase tracking-wider text-gray-400 border-b pb-1">Basic Details</h3>
                  </div>

                  <div>
                    <label className="block text-sm font-semibold mb-1 text-gray-700">
                      Delivery Order <span className="text-red-500">*</span>
                    </label>
                    <div className="flex flex-row items-center">
                      <input
                        type="text"
                        placeholder="Select Account"
                        className="w-full border border-gray-300 text-sm rounded-l-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color focus:border-theme-color transition"
                        value={deliveryOrder?.doNumber || ""}
                        readOnly
                      />
                      {!deliveryOrder ?
                        <button className="bg-theme-color hover:bg-theme-color-h p-[5px] rounded-r-lg" onClick={openDeliveryOrderSelectForm}>
                          <ManageSearchIcon className="text-white"/>
                        </button> 
                        :
                        <button className="bg-red-400 hover:bg-red-500 p-[5px] rounded-r-lg" onClick={()=>setDeliveryOrder(null)}>
                          <RemoveCircleIcon className="text-white"/>
                        </button>
                      }
                    </div>
                  </div>

                  <div>
                    <label className="block text-sm font-semibold mb-1 text-gray-700">
                      (Cr) Revenue Account <span className="text-red-500">*</span>
                    </label>
                    <div className="flex flex-row items-center">
                      <input
                        type="text"
                        placeholder="Select Account"
                        className="w-full border border-gray-300 text-sm rounded-l-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color focus:border-theme-color transition"
                        value={glAccount?.accountName || ""}
                        readOnly
                      />
                      {!glAccount ?
                        <button className="bg-theme-color hover:bg-theme-color-h p-[5px] rounded-r-lg" onClick={openGLAccountSelectForm}>
                          <ManageSearchIcon className="text-white"/>
                        </button> 
                        :
                        <button className="bg-red-400 hover:bg-red-500 p-[5px] rounded-r-lg" onClick={()=>setGLAccount(null)}>
                          <RemoveCircleIcon className="text-white"/>
                        </button>
                      }
                    </div>
                  </div>

                  <div className="md:col-span-2">
                    <div className="bg-white border border-gray-200 rounded-2xl p-6 shadow-sm flex flex-col lg:flex-row justify-between items-start lg:items-center gap-6">
                      
                      {/* Left Side: Details Breakdown */}
                      <div className="flex gap-4 w-full lg:w-auto">
                        <div className="bg-theme-color/10 p-3 rounded-xl h-fit">
                          <AccountBalanceWalletIcon className="text-theme-color" />
                        </div>
                        
                        <div className="flex-1 space-y-3">
                          <div>
                            <p className="text-[11px] font-bold uppercase tracking-widest text-gray-400">
                              Transaction Summary
                            </p>
                            <p className="text-xs text-gray-500">Breakdown of all line items</p>
                          </div>

                          {/* Mini Table for Subtotal, Discount, Tax */}
                          <div className="grid grid-cols-1 gap-2 border-t border-gray-50 pt-3">
                            <div className="hidden justify-between items-center gap-8">
                              <span className="text-xs font-medium text-gray-500">Subtotal</span>
                              <span className="text-sm font-semibold text-gray-700">
                                {getCurrency?.symbol} {FormatValueToDecimal(deliveryOrder?.subTotal)}
                              </span>
                            </div>
                            
                            <div className="hidden justify-between items-center gap-8">
                              <span className="text-xs font-medium text-gray-500">Total Discount</span>
                              <span className="text-sm font-semibold text-red-500">
                                - {getCurrency?.symbol} {FormatValueToDecimal(deliveryOrder?.totalDiscount)}
                              </span>
                            </div>

                            <div className="hidden justify-between items-center gap-8">
                              <span className="text-xs font-medium text-gray-500">Tax Amount</span>
                              <span className="text-sm font-semibold text-gray-700">
                                + {getCurrency?.symbol} {FormatValueToDecimal(deliveryOrder?.taxAmount)}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Right Side: Final Total & Status */}
                      <div className="w-full lg:w-auto text-left lg:text-right border-t lg:border-t-0 pt-4 lg:pt-0 border-gray-100">
                        <p className="text-[10px] font-bold uppercase tracking-widest text-gray-400 mb-1">
                          Final Total Amount
                        </p>
                        <div className="flex items-baseline justify-start lg:justify-end gap-2 mb-2">
                          <span className="text-4xl font-black text-gray-900 tracking-tight">
                            {`${getCurrency?.symbol || ""} ${FormatValueToDecimal(deliveryOrder?.amount)}`}
                          </span>
                        </div>

                        {/* Visual indicator of validation */}
                        {deliveryOrder?.amount > 0 ? (
                          <span className="inline-flex items-center text-[10px] font-bold text-green-600 bg-green-50 px-2.5 py-1 rounded-full uppercase tracking-tight border border-green-100">
                            <span className="mr-1">●</span> Ready to Save
                          </span>
                        ) : (
                          <span className="inline-flex items-center text-[10px] font-bold text-amber-600 bg-amber-50 px-2.5 py-1 rounded-full uppercase tracking-tight border border-amber-100">
                            <span className="mr-1">○</span> No amount detected
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                </>
              </div>
            </div>

            {/* Footer */}
            <div className="px-8 py-6 border-t bg-white flex justify-end items-center space-x-4">
              <button
                onClick={closeModal}
                className="px-6 py-2.5 rounded-lg border border-gray-300 text-gray-600 hover:bg-gray-50 transition font-semibold text-sm"
              >
                Cancel
              </button>
              <button
                onClick={handleSubmit}
                className="px-10 py-2.5 rounded-lg bg-theme-color text-white font-bold hover:opacity-90 shadow-lg shadow-theme-color/20 transition active:scale-95 text-sm"
              >
                Save Transaction
              </button>
            </div>
          </motion.div>
        </motion.div>
      </AnimatePresence>
      
      {/* <CrAccountsReceivablesChartOfAccountsSelect  */}
      <ChartOfAccountsSelect 
        visible={showGLAccountSelectForm} 
        onClose={closeGLAccountSelectForm}
        modalName={"Select Account"}
        data={glAccount} setData={setGLAccount}
      />
      
      <DeliveryOrderCustomerSelect 
        visible={showDeliveryOrderSelectForm} 
        onClose={closeDeliveryOrderSelectForm}
        modalName={"Select Available DO"}
        data={deliveryOrder} setData={setDeliveryOrder}
        customer={customer}
      />

      <div className="fixed top-5 right-5 z-50 flex flex-col space-y-2">
        <FailMessage message={failMessage} onClose={() => setFailMessage("")} />
      </div>

      { loading && <Loading />}
    </>
  );
};
const ViewGLAccountModal = ({
  visible, onClose, onSave, modalName,
  salesInvoiceDetails, setSalesInvoiceDetails,
  lineItemSelections, setLineItemSelections,
}) => {
  
  const getCurrency = JSON.parse(localStorage.getItem("currency") || "{}");
  const [totalSalesInvoiceAmount, setTotalSalesInvoiceAmount] = useState(0);
  const [collapsedDOs, setCollapsedDOs] = useState({});

  const toggleDO = (id) => {
    setCollapsedDOs((prev) => ({
      ...prev,
      [id]: !prev[id], // Toggle the collapsed state
    }));
  };

  const closeModal = () => {
    onClose();
  };

  const [currentPageGLAccount, setCurrentPageGLAccount] = useState(1);

  const headersGLAccount = [
    'DO NUMBER', 
    'ACCOUNT', 
    // 'SUBTOTAL', 
    // 'TOTAL DISCOUNT', 
    // 'TAX AMOUNT', 
    'TOTAL AMOUNT', 
  ]
  const accessorsGLAccount = [
    'deliveryOrderDONumber', 
    'glAccountName', 
    // 'subTotal', 
    // 'totalDiscount', 
    // 'taxAmount', 
    'totalAmount', 
  ]

  useEffect(() => {
    const _totalSalesInvoiceAmount = salesInvoiceDetails?.reduce((acc, item) => acc + (Number(item?.totalAmount) || 0), 0) || 0;
    setTotalSalesInvoiceAmount(_totalSalesInvoiceAmount)
  }, [salesInvoiceDetails])

  if (!visible) return null;

  return (
    <>
      <AnimatePresence>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 bg-slate-900/50 backdrop-blur-sm flex items-center justify-center z-50 p-4"
        >
          <motion.div
            initial={{ scale: 0.95, opacity: 0, y: 20 }}
            animate={{ scale: 1, opacity: 1, y: 0 }}
            exit={{ scale: 0.95, opacity: 0, y: 20 }}
            className="bg-gray-100 rounded-2xl shadow-2xl w-full max-w-5xl overflow-hidden flex flex-col max-h-[90vh]"
          >
            {/* Header */}
            <div className="px-8 py-5 bg-white border-b border-gray-200 flex justify-between items-center">
              <div>
                <h2 className="text-2xl font-bold text-gray-800 tracking-tight">{modalName}</h2>
                <p className="text-sm text-gray-500">Transaction details below</p>
              </div>
              <button onClick={closeModal} className="text-gray-400 hover:text-gray-600 transition p-2 hover:bg-gray-100 rounded-full">
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>

            <div className="p-8 overflow-y-auto custom-scrollbar">
              <div className="py-5 space-y-5">
                <div className="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden">
                  <CreateTable
                    tableName={"SalesInvoice"}
                    headers={headersGLAccount}
                    accessors={accessorsGLAccount}
                    data={salesInvoiceDetails}
                    actions={[]}
                    currentPage={currentPageGLAccount}
                    setCurrentPage={setCurrentPageGLAccount}
                    itemsPerPage={10}
                    totalItems={salesInvoiceDetails?.length}
                  />
                </div>

                {salesInvoiceDetails.length > 0 && (
                  <div className="shadow-sm overflow-hidden gap-4 flex flex-col p-4 bg-gray-50">
                    {salesInvoiceDetails.map((doGroup) => {
                      const doId = doGroup.deliveryOrderId;
                      const isExpanded = !collapsedDOs[doId];

                      return (
                        <div key={doId} className="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden transition-all">
                          <div 
                            onClick={() => toggleDO(doId)} 
                            className={`
                              px-6 py-4 flex justify-between items-center cursor-pointer transition-all duration-200
                              ${isExpanded ? 'bg-white border-b border-gray-200' : 'bg-gray-50/50 hover:bg-gray-100'}
                            `}
                          >
                            {/* Left Side: DO Number & Icon */}
                            <div className="flex items-center gap-3">
                              <div className={`transition-transform duration-200 ${isExpanded ? 'rotate-180' : ''}`}>
                                  <ExpandMoreIcon className="text-gray-400" />
                              </div>
                              <div className="flex flex-col">
                                <span className="text-[10px] uppercase font-bold text-gray-400 tracking-wider leading-none">Delivery Order</span>
                                <span className="text-sm font-bold text-theme-color uppercase tracking-tight">
                                  {doGroup.deliveryOrderDONumber ?? "DO-UNKNOWN"}
                                </span>
                              </div>
                            </div>

                            {/* Right Side: Total Amount */}
                            <div className="flex items-center gap-6">
                              <div className="text-right">
                                <span className="block text-[10px] uppercase font-bold text-gray-400 leading-none mb-1">Total Amount</span>
                                <span className="text-sm font-mono font-bold text-gray-900">
                                  {`${getCurrency?.symbol ? getCurrency?.symbol : ""}${FormatValueToDecimal(doGroup.totalAmount)}`}
                                </span>
                              </div>
                            </div>
                          </div>

                          {isExpanded && (
                            <div className="overflow-x-auto animate-in fade-in slide-in-from-top-1">
                              <table className="w-full text-left border-collapse">
                                <thead>
                                  <tr className="bg-white border-b border-gray-100">
                                    <th className="px-6 py-3 text-[11px] font-bold text-gray-500 uppercase tracking-wider">Item Details</th>
                                    <th className="px-6 py-3 text-[11px] font-bold text-gray-500 uppercase tracking-wider w-24 text-center">Qty</th>
                                    <th className="px-6 py-3 text-[11px] font-bold text-gray-500 uppercase tracking-wider w-32 text-center font-mono">Price</th>
                                    <th className="px-6 py-3 text-[11px] font-bold text-gray-500 uppercase tracking-wider w-64">Cost of Goods (Dr)</th>
                                    <th className="px-6 py-3 text-[11px] font-bold text-gray-500 uppercase tracking-wider w-64">Inventory (Cr)</th>
                                  </tr>
                                </thead>
                                <tbody className="divide-y divide-gray-50">
                                  {doGroup?.deliveryOrder?.deliveryOrderDetailLines?.map((line) => {
                                    const selection = lineItemSelections.find(item => item.lineItemId === line.id) || {};
                                    const drAccount = selection.debitAccount;
                                    const crAccount = selection.creditAccount;

                                    return (
                                      <tr key={line.id} className="hover:bg-gray-50/50">
                                        <td className="px-6 py-4">
                                          <div className="text-sm font-bold text-gray-900">{line.itemDescription}</div>
                                          <div className="text-[11px] text-gray-400 font-mono">{line.itemCode}</div>
                                        </td>
                                        <td className="px-6 py-4 text-center text-sm">{line.receivedQty}</td>
                                        <td className="px-6 py-4 text-center text-sm font-mono font-bold">
                                          {`${getCurrency?.symbol ? getCurrency?.symbol : ""}${FormatValueToDecimal(line?.unitPrice)}`}
                                          
                                        </td>

                                        {/* DEBIT ACCOUNT (DR) */}
                                        <td className="px-6 py-4">
                                          <div className="flex flex-row items-center">
                                            <div className="text-sm font-bold text-gray-900">{drAccount ? `${drAccount.accountNumber} - ${drAccount.accountName}` : ""}</div>
                                          </div>
                                        </td>

                                        {/* CREDIT ACCOUNT (CR) */}
                                        <td className="px-6 py-4">
                                          <div className="flex flex-row items-center">
                                            <div className="text-sm font-bold text-gray-900">{crAccount ? `${crAccount.accountNumber} - ${crAccount.accountName}` : ""}</div>
                                          </div>
                                        </td>
                                      </tr>
                                    );
                                  })}
                                </tbody>
                              </table>
                            </div>
                          )}
                        </div>
                      );
                    })}
                  </div>
                )}

                <div className="md:col-span-2">
                  <div className="bg-white border border-gray-200 rounded-2xl p-6 shadow-sm flex flex-col md:flex-row justify-between items-center gap-4">
                    <div className="flex items-center gap-4">
                      <div className="bg-theme-color/10 p-3 rounded-xl">
                        <AccountBalanceWalletIcon className="text-theme-color" />
                      </div>
                      <div>
                        <p className="text-[11px] font-bold uppercase tracking-widest text-gray-400">
                          Total Transaction Amount
                        </p>
                        <p className="text-xs text-gray-500">
                          Sum of all sales invoice line items above
                        </p>
                      </div>
                    </div>

                    <div className="text-center md:text-right">
                      <div className="flex items-baseline justify-center md:justify-end gap-2">
                        <span className="text-3xl font-black text-gray-800 tracking-tight">
                          {`${getCurrency?.symbol ? getCurrency?.symbol : ""} ${FormatValueToDecimal(totalSalesInvoiceAmount)}`}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Footer */}
            <div className="px-8 py-6 border-t bg-white flex justify-end items-center space-x-4">
              <button
                onClick={closeModal}
                className="px-6 py-2.5 rounded-lg border border-gray-300 text-gray-600 hover:bg-gray-50 transition font-semibold text-sm"
              >
                Cancel
              </button>
            </div>
          </motion.div>
        </motion.div>
      </AnimatePresence>
    </>
  );
};
//#endregion














//#region Filter
const FilterModal = ({
  visible, onClose, modalName,
  customerFilter, setCustomerFilter,
  statusFilter, setStatusFilter,
}) => {
  const [failMessage, setFailMessage] = useState("");
  const [_customerFilter, _setCustomerFilter] = useState(customerFilter);
  const [_statusFilter, _setStatusFilter] = useState(statusFilter);

  useEffect(() => {
    if(visible){
      _setCustomerFilter(customerFilter)
      _setStatusFilter(statusFilter)
    }
  }, [visible, customerFilter, statusFilter])

  const handleSubmit = async () => {
    setCustomerFilter(_customerFilter);
    setStatusFilter(_statusFilter);
    closeModal();
  };

  const resetLocalVariables = () => {
    setFailMessage("");
  };

  const closeModal = () => {
    onClose();
    resetLocalVariables();
  };

//#region Customer
  const [showCustomerSelectForm, setShowCustomerSelectForm] = useState(false);
  const openCustomerSelectForm = () => {
    setShowCustomerSelectForm(true);
  }
  const closeCustomerSelectForm = () => {
    setShowCustomerSelectForm(false);
  }
//#endregion

  if (!visible) return null;

  return (
    <>
      {/* Background overlay */}
      <AnimatePresence>
        {visible && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 bg-gray-200 bg-opacity-70 flex items-center justify-center z-50"
          >
            {/* Modal container */}
            <motion.div
              initial={{ scale: 0.9, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.9, opacity: 0 }}
              transition={{ duration: 0.2 }}
              className="bg-gray-100 rounded-2xl shadow-lg w-full max-w-lg p-8"
            >
              <h2 className="text-2xl font-semibold border-b pb-3 mb-6">
                {modalName}
              </h2>

              <div className="space-y-5 max-h-[500px] overflow-y-auto short:max-h-[300px] medium:h-[400px] pr-1">
                <div>
                  <label className="block text-sm font-semibold mb-1 text-gray-700">
                    Customer <span className="text-red-500">*</span>
                  </label>
                  <div className="flex flex-row items-center">
                    <input
                      type="text"
                      placeholder="Select Customer"
                      className="w-full border border-gray-300 text-sm rounded-l-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color focus:border-theme-color transition"
                      value={`${_customerFilter ? `${_customerFilter?.customerId} - ${_customerFilter?.name1}` : ""}`}
                      readOnly
                    />
                    {!_customerFilter ?
                      <button className="bg-theme-color hover:bg-theme-color-h p-[5px] rounded-r-lg" onClick={openCustomerSelectForm}>
                        <PersonSearchIcon className="text-white"/>
                      </button> 
                      :
                      <button className="bg-red-400 hover:bg-red-500 p-[5px] rounded-r-lg" onClick={()=>_setCustomerFilter(null)}>
                        <RemoveCircleIcon className="text-white"/>
                      </button>
                    }
                  </div>
                </div>

                <div>
                  <label className="block text-sm font-medium mb-1 text-gray-700">
                    Status
                  </label>
                  <InvoiceStatusSelectWithAll data={_statusFilter} setData={_setStatusFilter} isEditable={true}/>
                </div>
              </div>

              {/* Buttons */}
              <div className="flex justify-end space-x-3 mt-8 border-t pt-4">
                <button
                  onClick={closeModal}
                  className="px-5 py-2 rounded-lg border border-gray-300 text-gray-700 hover:bg-gray-100 transition"
                >
                  Cancel
                </button>
                <button
                  onClick={handleSubmit}
                  className="px-5 py-2 rounded-lg bg-theme-color text-white font-medium hover:opacity-90 transition"
                >
                  Save
                </button>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>

      <CustomerSelect 
        visible={showCustomerSelectForm} 
        onClose={closeCustomerSelectForm}
        modalName={"Select Customer"}
        data={_customerFilter} setData={_setCustomerFilter}
      />

      {/* Alert */}
      <div className="fixed top-5 right-5 z-[9999] flex flex-col space-y-2">
        <FailMessage message={failMessage} onClose={() => setFailMessage("")} />
      </div>
    </>
  );
};
//#endregion